var _defs, _rect, _use, _use2, _path, _path2, _image, _image2, _path3, _rect2, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _image3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _rect3, _path73, _path74, _path75, _path76, _path77, _g2, _path78, _path79, _path80, _path81, _image4, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12H(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160.59 227.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}.cls-3{fill:#bc141a;}.cls-4{fill:#fed783;}.cls-5{fill:#ebc17d;}.cls-6{fill:#ca974d;}.cls-7{fill:#fde4e0;}.cls-8{fill:#c08329;}.cls-9{fill:url(#linear-gradient);}.cls-10{clip-path:url(#clip-path);}.cls-11{opacity:0.36;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:url(#linear-gradient-36);}.cls-47{fill:url(#linear-gradient-37);}.cls-48{fill:url(#linear-gradient-38);}.cls-49{fill:url(#linear-gradient-39);}.cls-50{fill:url(#linear-gradient-40);}.cls-51{fill:url(#linear-gradient-41);}.cls-52{fill:url(#linear-gradient-42);}.cls-53{fill:url(#linear-gradient-43);}.cls-54{fill:url(#linear-gradient-44);}.cls-55{fill:url(#linear-gradient-45);}.cls-56{fill:url(#linear-gradient-46);}.cls-57{fill:url(#linear-gradient-47);}.cls-58{fill:url(#linear-gradient-48);}.cls-59{fill:url(#linear-gradient-49);}.cls-60{fill:url(#linear-gradient-50);}.cls-61{fill:url(#linear-gradient-51);}.cls-62{fill:url(#linear-gradient-52);}.cls-63{fill:url(#linear-gradient-53);}.cls-64{fill:url(#linear-gradient-54);}.cls-65{fill:url(#linear-gradient-55);}.cls-66{fill:url(#linear-gradient-56);}.cls-67{fill:url(#linear-gradient-57);}.cls-68{fill:url(#linear-gradient-58);}.cls-69{fill:url(#linear-gradient-59);}.cls-70{fill:url(#linear-gradient-60);}.cls-71{fill:url(#linear-gradient-61);}.cls-72{fill:url(#linear-gradient-62);}.cls-73{fill:url(#linear-gradient-63);}.cls-74{fill:url(#linear-gradient-64);}.cls-75{fill:url(#linear-gradient-65);}.cls-76{fill:url(#linear-gradient-66);}.cls-77{fill:url(#linear-gradient-67);}.cls-78{fill:url(#linear-gradient-68);}.cls-79{fill:url(#linear-gradient-69);}.cls-80{fill:url(#linear-gradient-70);}.cls-81{fill:url(#linear-gradient-71);}.cls-82{fill:url(#linear-gradient-72);}.cls-83{fill:url(#linear-gradient-73);}.cls-84{fill:#fbd5e2;}.cls-85{fill:#c2151c;}.cls-86{fill:#6c301e;}.cls-87{fill:#fff;}.cls-88{fill:url(#linear-gradient-74);}.cls-89{fill:#bf151b;}.cls-90{fill:url(#linear-gradient-75);}.cls-91{fill:url(#linear-gradient-76);}.cls-92{fill:#6fbe44;}.cls-93{fill:#961619;}.cls-94{fill:#ba1b20;}.cls-95{fill:#d44234;}.cls-96{fill:#d31820;}.cls-97{fill:#4cb749;}.cls-98{fill:url(#linear-gradient-77);}.cls-99{fill:url(#linear-gradient-78);}.cls-100{fill:url(#linear-gradient-79);}.cls-101{fill:url(#linear-gradient-80);}.cls-102{fill:url(#linear-gradient-81);}.cls-103{fill:url(#linear-gradient-82);}.cls-104{fill:url(#linear-gradient-83);}.cls-105{fill:url(#linear-gradient-84);}.cls-106{fill:url(#linear-gradient-85);}.cls-107{clip-path:url(#clip-path-2);}.cls-108{fill:url(#linear-gradient-86);}.cls-109{fill:url(#linear-gradient-87);}.cls-110{fill:url(#linear-gradient-88);}.cls-111{fill:url(#linear-gradient-89);}.cls-112{fill:url(#linear-gradient-90);}.cls-113{fill:url(#linear-gradient-91);}.cls-114{fill:url(#linear-gradient-92);}.cls-115{fill:url(#linear-gradient-93);}.cls-116{fill:url(#linear-gradient-94);}.cls-117{fill:url(#linear-gradient-95);}.cls-118{fill:url(#linear-gradient-96);}.cls-119{fill:url(#linear-gradient-97);}.cls-120{fill:url(#linear-gradient-98);}.cls-121{fill:url(#linear-gradient-99);}.cls-122{fill:url(#linear-gradient-100);}.cls-123{fill:url(#linear-gradient-101);}.cls-124{fill:url(#linear-gradient-102);}.cls-125{fill:url(#linear-gradient-103);}.cls-126{fill:url(#linear-gradient-104);}.cls-127{fill:url(#linear-gradient-105);}.cls-128{fill:url(#linear-gradient-106);}.cls-129{fill:url(#linear-gradient-107);}.cls-130{fill:url(#linear-gradient-108);}.cls-131{fill:url(#linear-gradient-109);}.cls-132{fill:url(#linear-gradient-110);}.cls-133{fill:url(#linear-gradient-111);}.cls-134{fill:url(#linear-gradient-112);}.cls-135{fill:url(#linear-gradient-113);}.cls-136{fill:url(#linear-gradient-114);}.cls-137{fill:url(#linear-gradient-115);}.cls-138{fill:url(#linear-gradient-116);}.cls-139{fill:url(#linear-gradient-117);}.cls-140{fill:url(#linear-gradient-118);}.cls-141{fill:url(#linear-gradient-119);}.cls-142{fill:url(#linear-gradient-120);}.cls-143{fill:url(#linear-gradient-121);}.cls-144{fill:url(#linear-gradient-122);}.cls-145{fill:url(#linear-gradient-123);}.cls-146{fill:url(#linear-gradient-124);}.cls-147{fill:url(#linear-gradient-125);}.cls-148{fill:url(#linear-gradient-126);}.cls-149{fill:url(#linear-gradient-127);}.cls-150{fill:url(#linear-gradient-128);}.cls-151{fill:url(#linear-gradient-129);}.cls-152{fill:url(#linear-gradient-130);}.cls-153{fill:url(#linear-gradient-131);}.cls-154{fill:url(#linear-gradient-132);}.cls-155{fill:url(#linear-gradient-133);}.cls-156{fill:url(#linear-gradient-134);}.cls-157{fill:url(#linear-gradient-135);}.cls-158{fill:url(#linear-gradient-136);}.cls-159{fill:url(#linear-gradient-137);}.cls-160{fill:url(#linear-gradient-138);}.cls-161{fill:url(#linear-gradient-139);}.cls-162{fill:url(#linear-gradient-140);}.cls-163{fill:url(#linear-gradient-141);}.cls-164{fill:url(#linear-gradient-142);}.cls-165{fill:url(#linear-gradient-143);}.cls-166{fill:url(#linear-gradient-144);}.cls-167{fill:url(#linear-gradient-145);}.cls-168{fill:url(#linear-gradient-146);}.cls-169{fill:url(#linear-gradient-147);}.cls-170{fill:url(#linear-gradient-148);}.cls-171{fill:url(#linear-gradient-149);}.cls-172{fill:url(#linear-gradient-150);}.cls-173{fill:url(#linear-gradient-151);}.cls-174{fill:url(#linear-gradient-152);}.cls-175{fill:url(#linear-gradient-153);}.cls-176{fill:url(#linear-gradient-154);}.cls-177{fill:url(#linear-gradient-155);}.cls-178{fill:url(#linear-gradient-156);}.cls-179{fill:url(#linear-gradient-157);}.cls-180{fill:url(#linear-gradient-158);}.cls-181{fill:url(#linear-gradient-159);}.cls-182{fill:url(#linear-gradient-160);}.cls-183{fill:url(#linear-gradient-161);}.cls-184{fill:url(#linear-gradient-162);}.cls-185{fill:url(#linear-gradient-163);}.cls-186{fill:url(#linear-gradient-164);}.cls-187{fill:url(#linear-gradient-165);}.cls-188{fill:url(#linear-gradient-166);}.cls-189{fill:url(#linear-gradient-167);}.cls-190{fill:url(#linear-gradient-168);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 137.92,
    y1: 70.59,
    x2: 61.42,
    y2: 108.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.59,75.14l-10.13-1.88c-4.94,8.39-14.66,20.6-28.53,18-14.73-2.8-18.24-11.93-19.05-17a9.2,9.2,0,0,0-3.33,1.16C55.68,82.41,29.6,119,29.6,119l99.6-11.35V82.27C129.2,75.67,123.59,75.14,123.59,75.14Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 73.51,
    y1: 88.01,
    x2: 15.23,
    y2: 165.91,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 80.45,
    y1: 93.21,
    x2: 22.17,
    y2: 171.1,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 87.4,
    y1: 98.4,
    x2: 29.11,
    y2: 176.3,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 94.34,
    y1: 103.59,
    x2: 36.05,
    y2: 181.49,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 101.28,
    y1: 108.79,
    x2: 42.99,
    y2: 186.69,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 108.22,
    y1: 113.98,
    x2: 49.93,
    y2: 191.87,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 115.16,
    y1: 119.18,
    x2: 56.87,
    y2: 197.07,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 122.1,
    y1: 124.37,
    x2: 63.81,
    y2: 202.27,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 129.04,
    y1: 129.56,
    x2: 70.75,
    y2: 207.46,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 132.27,
    y1: 131.98,
    x2: 73.98,
    y2: 209.87,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 125.33,
    y1: 126.78,
    x2: 67.05,
    y2: 204.67,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 118.38,
    y1: 121.59,
    x2: 60.1,
    y2: 199.49,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 111.44,
    y1: 116.4,
    x2: 53.16,
    y2: 194.29,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 104.5,
    y1: 111.21,
    x2: 46.22,
    y2: 189.1,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 97.56,
    y1: 106.01,
    x2: 39.28,
    y2: 183.91,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 90.62,
    y1: 100.82,
    x2: 32.34,
    y2: 178.71,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 83.68,
    y1: 95.62,
    x2: 25.4,
    y2: 173.52,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 76.74,
    y1: 90.43,
    x2: 18.46,
    y2: 168.32,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 62.25,
    y1: 79.58,
    x2: 3.96,
    y2: 157.48,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 69.19,
    y1: 84.78,
    x2: 10.9,
    y2: 162.67,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 76.13,
    y1: 89.97,
    x2: 17.84,
    y2: 167.86,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 83.07,
    y1: 95.16,
    x2: 24.78,
    y2: 173.06,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 90.01,
    y1: 100.36,
    x2: 31.72,
    y2: 178.26,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 96.95,
    y1: 105.55,
    x2: 38.66,
    y2: 183.45,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 103.89,
    y1: 110.74,
    x2: 45.6,
    y2: 188.64,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 110.83,
    y1: 115.94,
    x2: 52.54,
    y2: 193.84,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 117.77,
    y1: 121.13,
    x2: 59.49,
    y2: 199.02,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 121,
    y1: 123.55,
    x2: 62.71,
    y2: 201.45,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 114.06,
    y1: 118.35,
    x2: 55.78,
    y2: 196.25,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 107.12,
    y1: 113.16,
    x2: 48.83,
    y2: 191.05,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 100.18,
    y1: 107.97,
    x2: 41.89,
    y2: 185.87,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 93.24,
    y1: 102.77,
    x2: 34.95,
    y2: 180.67,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 86.3,
    y1: 97.58,
    x2: 28.02,
    y2: 175.47,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 79.36,
    y1: 92.39,
    x2: 21.07,
    y2: 170.28,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 72.42,
    y1: 87.19,
    x2: 14.13,
    y2: 165.09,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 65.48,
    y1: 82,
    x2: 7.19,
    y2: 159.9,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 94.42,
    y1: 103.65,
    x2: 36.13,
    y2: 181.56,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 101.35,
    y1: 108.86,
    x2: 43.07,
    y2: 186.74,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 108.3,
    y1: 114.04,
    x2: 50.01,
    y2: 191.94,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 115.24,
    y1: 119.24,
    x2: 56.95,
    y2: 197.14,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 122.18,
    y1: 124.43,
    x2: 63.89,
    y2: 202.33,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 129.12,
    y1: 129.63,
    x2: 70.84,
    y2: 207.52,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 136.06,
    y1: 134.82,
    x2: 77.78,
    y2: 212.71,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 143,
    y1: 140.01,
    x2: 84.71,
    y2: 217.91,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 149.94,
    y1: 145.2,
    x2: 91.65,
    y2: 223.1,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 153.17,
    y1: 147.62,
    x2: 94.88,
    y2: 225.52,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 146.23,
    y1: 142.43,
    x2: 87.95,
    y2: 220.32,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 139.29,
    y1: 137.23,
    x2: 81,
    y2: 215.13,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 132.35,
    y1: 132.04,
    x2: 74.06,
    y2: 209.94,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 125.41,
    y1: 126.85,
    x2: 67.12,
    y2: 204.74,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 118.46,
    y1: 121.66,
    x2: 60.18,
    y2: 199.55,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 111.53,
    y1: 116.46,
    x2: 53.24,
    y2: 194.36,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 104.58,
    y1: 111.27,
    x2: 46.3,
    y2: 189.16,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 97.64,
    y1: 106.08,
    x2: 39.36,
    y2: 183.97,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 83.15,
    y1: 95.23,
    x2: 24.86,
    y2: 173.12,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 90.09,
    y1: 100.42,
    x2: 31.81,
    y2: 178.31,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 97.03,
    y1: 105.61,
    x2: 38.74,
    y2: 183.51,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 103.97,
    y1: 110.81,
    x2: 45.69,
    y2: 188.7,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 110.91,
    y1: 116,
    x2: 52.62,
    y2: 193.9,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 117.85,
    y1: 121.19,
    x2: 59.56,
    y2: 199.1,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 124.79,
    y1: 126.39,
    x2: 66.5,
    y2: 204.29,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 131.73,
    y1: 131.58,
    x2: 73.44,
    y2: 209.48,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 138.67,
    y1: 136.77,
    x2: 80.38,
    y2: 214.68,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 141.9,
    y1: 139.19,
    x2: 83.62,
    y2: 217.08,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 134.96,
    y1: 134,
    x2: 76.68,
    y2: 211.89,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 128.02,
    y1: 128.8,
    x2: 69.73,
    y2: 206.71,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 121.08,
    y1: 123.61,
    x2: 62.79,
    y2: 201.51,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 114.14,
    y1: 118.41,
    x2: 55.85,
    y2: 196.31,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 107.2,
    y1: 113.22,
    x2: 48.91,
    y2: 191.12,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 100.26,
    y1: 108.02,
    x2: 41.97,
    y2: 185.93,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 93.33,
    y1: 102.83,
    x2: 35.03,
    y2: 180.74,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 86.39,
    y1: 97.63,
    x2: 28.09,
    y2: 175.54,
    gradientTransform: "translate(8.77 -49.89) rotate(9.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 57.55,
    y1: -4.47,
    x2: 74.49,
    y2: 22.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f181b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 82.93,
    y1: 79.14,
    x2: 88.55,
    y2: 79.14,
    gradientTransform: "translate(-0.85 6.83) rotate(-1.31)",
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 111.56,
    y1: 83.99,
    x2: 94.06,
    y2: 114.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 104.33,
    y1: 65.09,
    x2: 85.82,
    y2: 110.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 103.49,
    y1: 64.73,
    x2: 84.99,
    y2: 109.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 103.36,
    y1: 64.59,
    x2: 84.83,
    y2: 109.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 103.5,
    y1: 64.66,
    x2: 84.96,
    y2: 109.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 103.92,
    y1: 64.85,
    x2: 85.39,
    y2: 109.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 104.57,
    y1: 65.13,
    x2: 86.05,
    y2: 110.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 105.49,
    y1: 65.53,
    x2: 86.97,
    y2: 110.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 132.5,
    y1: 85.82,
    x2: 116.01,
    y2: 94.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 594.51,
    y1: -104.83,
    x2: 518.01,
    y2: -66.83,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,151.2l10.13,1.88c4.94-8.39,14.66-20.6,28.52-18,14.74,2.8,18.25,11.93,19.05,17A9,9,0,0,0,96,150.94c6.87-7,33-43.57,33-43.57L29.37,118.72v25.35C29.37,150.67,35,151.2,35,151.2Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 495.2,
    y1: -159.82,
    x2: 436.92,
    y2: -81.93,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 502.14,
    y1: -154.63,
    x2: 443.86,
    y2: -76.74,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 509.09,
    y1: -149.44,
    x2: 450.8,
    y2: -71.54,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 516.03,
    y1: -144.24,
    x2: 457.74,
    y2: -66.34,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 522.97,
    y1: -139.05,
    x2: 464.68,
    y2: -61.16,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 529.91,
    y1: -133.86,
    x2: 471.63,
    y2: -55.97,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 536.85,
    y1: -128.66,
    x2: 478.56,
    y2: -50.77,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 543.79,
    y1: -123.47,
    x2: 485.5,
    y2: -45.57,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 550.73,
    y1: -118.28,
    x2: 492.44,
    y2: -40.38,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 553.96,
    y1: -115.86,
    x2: 495.67,
    y2: -37.97,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 547.02,
    y1: -121.05,
    x2: 488.74,
    y2: -43.17,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 540.08,
    y1: -126.25,
    x2: 481.79,
    y2: -48.35,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 533.14,
    y1: -131.44,
    x2: 474.85,
    y2: -53.55,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 526.19,
    y1: -136.63,
    x2: 467.91,
    y2: -58.74,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 519.25,
    y1: -141.83,
    x2: 460.97,
    y2: -63.93,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 512.31,
    y1: -147.02,
    x2: 454.03,
    y2: -69.13,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 505.37,
    y1: -152.22,
    x2: 447.09,
    y2: -74.32,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 498.43,
    y1: -157.41,
    x2: 440.15,
    y2: -79.51,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 483.94,
    y1: -168.26,
    x2: 425.65,
    y2: -90.35,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 490.88,
    y1: -163.06,
    x2: 432.59,
    y2: -85.16,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 497.82,
    y1: -157.87,
    x2: 439.54,
    y2: -79.97,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 504.76,
    y1: -152.67,
    x2: 446.47,
    y2: -74.77,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 511.7,
    y1: -147.48,
    x2: 453.41,
    y2: -69.58,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 518.64,
    y1: -142.29,
    x2: 460.35,
    y2: -64.39,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 525.58,
    y1: -137.09,
    x2: 467.3,
    y2: -59.2,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 532.52,
    y1: -131.9,
    x2: 474.23,
    y2: -54,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 539.46,
    y1: -126.71,
    x2: 481.18,
    y2: -48.81,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 542.69,
    y1: -124.29,
    x2: 484.41,
    y2: -46.4,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 535.75,
    y1: -129.49,
    x2: 477.47,
    y2: -51.6,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 528.81,
    y1: -134.68,
    x2: 470.53,
    y2: -56.78,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 521.87,
    y1: -139.87,
    x2: 463.58,
    y2: -61.97,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 514.93,
    y1: -145.06,
    x2: 456.64,
    y2: -67.16,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 507.99,
    y1: -150.26,
    x2: 449.71,
    y2: -72.37,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 501.05,
    y1: -155.45,
    x2: 442.76,
    y2: -77.55,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 494.11,
    y1: -160.65,
    x2: 435.82,
    y2: -82.74,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 487.17,
    y1: -165.84,
    x2: 428.88,
    y2: -87.94,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 516.11,
    y1: -144.19,
    x2: 457.82,
    y2: -66.28,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 523.05,
    y1: -138.99,
    x2: 464.76,
    y2: -61.09,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 529.99,
    y1: -133.8,
    x2: 471.7,
    y2: -55.9,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 536.93,
    y1: -128.6,
    x2: 478.64,
    y2: -50.7,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 543.87,
    y1: -123.41,
    x2: 485.58,
    y2: -45.51,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 550.81,
    y1: -118.21,
    x2: 492.53,
    y2: -40.32,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 557.75,
    y1: -113.02,
    x2: 499.47,
    y2: -35.13,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 564.69,
    y1: -107.83,
    x2: 506.41,
    y2: -29.93,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 571.63,
    y1: -102.63,
    x2: 513.35,
    y2: -24.74,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 574.86,
    y1: -100.22,
    x2: 516.57,
    y2: -22.32,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 567.92,
    y1: -105.41,
    x2: 509.64,
    y2: -27.52,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 560.98,
    y1: -110.6,
    x2: 502.7,
    y2: -32.71,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 554.04,
    y1: -115.8,
    x2: 495.75,
    y2: -37.9,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 547.1,
    y1: -120.99,
    x2: 488.81,
    y2: -43.1,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 540.15,
    y1: -126.18,
    x2: 481.88,
    y2: -48.29,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 533.22,
    y1: -131.38,
    x2: 474.93,
    y2: -53.48,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 526.27,
    y1: -136.57,
    x2: 467.99,
    y2: -58.68,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 519.33,
    y1: -141.76,
    x2: 461.05,
    y2: -63.87,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 504.84,
    y1: -152.61,
    x2: 446.56,
    y2: -74.72,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 511.78,
    y1: -147.42,
    x2: 453.5,
    y2: -69.53,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 518.72,
    y1: -142.23,
    x2: 460.44,
    y2: -64.33,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 525.66,
    y1: -137.03,
    x2: 467.38,
    y2: -59.14,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 532.6,
    y1: -131.84,
    x2: 474.32,
    y2: -53.94,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 539.54,
    y1: -126.65,
    x2: 481.25,
    y2: -48.74,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 546.48,
    y1: -121.45,
    x2: 488.2,
    y2: -43.56,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 553.42,
    y1: -116.26,
    x2: 495.14,
    y2: -38.36,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 560.37,
    y1: -111.07,
    x2: 502.08,
    y2: -33.17,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 563.59,
    y1: -108.65,
    x2: 505.31,
    y2: -30.75,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 556.65,
    y1: -113.84,
    x2: 498.37,
    y2: -35.95,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 549.72,
    y1: -119.04,
    x2: 491.42,
    y2: -41.13,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 542.77,
    y1: -124.23,
    x2: 484.49,
    y2: -46.33,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 535.83,
    y1: -129.42,
    x2: 477.55,
    y2: -51.53,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 528.89,
    y1: -134.62,
    x2: 470.61,
    y2: -56.72,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 521.95,
    y1: -139.81,
    x2: 463.66,
    y2: -61.91,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 515.02,
    y1: -145.01,
    x2: 456.72,
    y2: -67.1,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 508.08,
    y1: -150.21,
    x2: 449.78,
    y2: -72.3,
    gradientTransform: "translate(606.4 100.81) rotate(-170.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 514.15,
    y1: -179.89,
    x2: 531.09,
    y2: -153.28,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 543.44,
    y1: -85.79,
    x2: 549.06,
    y2: -85.79,
    gradientTransform: "translate(616.02 44.09) rotate(178.69)",
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 568.15,
    y1: -91.43,
    x2: 550.65,
    y2: -60.93,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 560.92,
    y1: -110.32,
    x2: 542.42,
    y2: -65.38,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 560.08,
    y1: -110.69,
    x2: 541.58,
    y2: -65.74,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 559.96,
    y1: -110.83,
    x2: 541.42,
    y2: -65.8,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 560.09,
    y1: -110.77,
    x2: 541.56,
    y2: -65.73,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 560.51,
    y1: -110.57,
    x2: 541.99,
    y2: -65.56,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 561.17,
    y1: -110.29,
    x2: 542.64,
    y2: -65.27,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 562.09,
    y1: -109.89,
    x2: 543.57,
    y2: -64.9,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 589.1,
    y1: -89.6,
    x2: 572.6,
    y2: -81.4,
    gradientTransform: "translate(615.16 50.92) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 153,
    height: 217,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACbUlEQVR4Xu3UQQrCQBBFwU7w/lceVwbBAUF9rqpWoSfLxz/WWrOxPcIbx+54e/oWFt96bugK7tw8wi9cTT0ig8w5VozOmrFk/IHIyImMnMioLZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kVE7REZOZORERu6cmePdT/ChY8aS8QePyKwZv3Y1ddsc18DnXgbrDscGDbMo4RF3AAAAAElFTkSuQmCC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1741.23,
    y: -515.82,
    width: 2406.31,
    height: 1210.9
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(3.23 4.5)",
    xlinkHref: "#image"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(3.23 4.5)",
    xlinkHref: "#image"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.15,36.62A12.93,12.93,0,0,0,26.7,40.8a8.7,8.7,0,0,0,4.35,1.53v.52a18.13,18.13,0,0,1-4.76-.9,20.75,20.75,0,0,1-4.79-2.26,22.91,22.91,0,0,1-3.92-3.07,15.42,15.42,0,0,1-3.67-2,10.94,10.94,0,0,1-3.06-3.85A12.49,12.49,0,0,1,9.76,25.4a11.17,11.17,0,0,1,3.18-8.15A10.37,10.37,0,0,1,20.63,14a10,10,0,0,1,7.43,3.25,11.34,11.34,0,0,1,3.14,8.2,11.56,11.56,0,0,1-2.24,7A11,11,0,0,1,23.15,36.62ZM20.44,15.25a5.92,5.92,0,0,0-4.73,2.1q-2.25,2.63-2.25,8c0,3.53.76,6.26,2.29,8.17a5.69,5.69,0,0,0,4.69,2.21,6,6,0,0,0,4.88-2.21c1.46-1.74,2.18-4.31,2.18-7.71a16.24,16.24,0,0,0-1.19-6.59,6.71,6.71,0,0,0-2.44-3A6.24,6.24,0,0,0,20.44,15.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.42,189.72a12.84,12.84,0,0,0-3.56-4.18,8.63,8.63,0,0,0-4.34-1.53v-.51a17.69,17.69,0,0,1,4.76.89,20.35,20.35,0,0,1,4.79,2.26,22.82,22.82,0,0,1,3.91,3.07,15.31,15.31,0,0,1,3.68,2,10.8,10.8,0,0,1,3.05,3.85,12.35,12.35,0,0,1,1.09,5.39,11.16,11.16,0,0,1-3.17,8.15,10.37,10.37,0,0,1-7.69,3.24,10,10,0,0,1-7.43-3.25,11.34,11.34,0,0,1-3.14-8.2,11.56,11.56,0,0,1,2.24-7A11,11,0,0,1,135.42,189.72Zm2.71,21.37a5.88,5.88,0,0,0,4.72-2.1q2.27-2.62,2.26-8.05c0-3.53-.76-6.26-2.29-8.17a5.7,5.7,0,0,0-4.69-2.21,6.06,6.06,0,0,0-4.89,2.21q-2.18,2.61-2.18,7.71a16.07,16.07,0,0,0,1.2,6.59,6.71,6.71,0,0,0,2.44,3A6.24,6.24,0,0,0,138.13,211.09Z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 14,
    transform: "translate(13.23 43.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsSAAALEgHS3X78AAABkElEQVQoU3WRTYsTQRCGn+qenslkk2wUJGJcD5uTF6+i5t/7AQviT1hwN0ogu7DGjDOZ/igP48SA8YG+dNVDv1UtqgrAx2cXajKLqpJ8ZLleCcDVYqEaE6HxhztRVT7NX6gtHcYZRIS4D/iqpXwyItQeYw3ttgER3n2/Efnw9LmKNbhRjhsVhNoT9wHjLMV0QPFoSPtQU28q2p8NAKaPJ9YgRiimJeOLKW6UM5yNcWc5tnRMLh9jMttJAFmZYXOLLTLcuMDkFhEhnwwQa8hKR2wCtjiSEEGMoKpY18nlbIxkBuMMxllC7bED10nL9UrabYOvWjR0WxJryCcFghBqT2oD/RjL9Uoy/qBJ0aTEfSAb5hhnSSHS3P2i3uy6je72f+Mt1yuJtae5r2gfakQg+UhzX6ExgQBJD/9k+pfe3H4VjYotc9ptQ6g8xll2334Qa8/r62vpe6XP2nO1uNT8vORsfs7m8y1ihberG+GIfySAL69eqqZEfVcdIh2TcQJftfhqf6rUoaonz/vZXP9X+w22eeYNpGzbQwAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 15,
    transform: "translate(132.23 168.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAAACXBIWXMAAAsSAAALEgHS3X78AAABf0lEQVQoU3WSS3PTQBCEv33pYUk4FARE+UUO/Af4/diYf5FwtYEDWJYt7e5wUHBIWWzVHnZ6e7qnaxARxu6X5Ur+h2lGzubdQsLZs129lzHcjhWV0RinSabZGHyttF2sJPrApK5IX074end3pfaMtF2uRDtD8iIjvy1JypTsVXFl80LazJZickcxm3Lz4TWuSjGZJXYBmzs2s+WF+KQkgnZmSMcalFYA5G9KXJniioR1PRd4DOLvQ1tNubjB5g6JQxOTWbTVlyYAdl3PRRtNXlfkt+WggiL0ntgHlFK4KiX6iERhXc/FAhSzKXbi0FYDQvSB7teZ2HlQitgHtNVIlKeZTj8axEdiH4h9pN0f+P3wEwDfdIQuDHbNEIEF8G1Pu2/IoqCM5rg74IqEdt9gc0fsAuHsiT4AoEQGn8poknKI2WSWdncApUCEpEoJXcC3PZ++PahL5BIi/tTTNx2n7w0f7++VP3YAHHcHfNsTu/D4+Z/tXdfz0c3+/Hb2rP4HdVDuw7ZUSvoAAAAASUVORK5CYII="
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.12,58.11l.08,15.34s8.75.25,10-4.75S74.12,58.11,74.12,58.11Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 77.45,
    y: 59.7,
    width: 7.5,
    height: 18.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.35,33.23s-6.78-7.18,0-8.77c0,0-1.59-5.18,8.38-6.78S125,9.7,121.79,77.1L94.27,73.91,83.51,50.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.12,72.11S89.89,60,90.29,46.79,83.11,18.88,68.75,27.65l-.63,7.46-3,10,3,1.34-.23,3.61.8,1.6-.6,1.59a13.55,13.55,0,0,1,1,1.4c.24.44-2,6.3,1.7,6.3,5.1,0,9.66-.17,10.29,2.71,1,4.4,2.28,7-1,7.79-13.05,3-14.33,3-14.33,3S57.58,103,88.29,105,124.18,77.5,124.18,77.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.7,38A4.13,4.13,0,0,0,73.19,38c1.88-.61,4.1-1.94,5.6.23l-1.25-.42a3.4,3.4,0,0,0-2.28.84s.22,1.94-1.35,1.86a1.2,1.2,0,0,1-1.2-1.56S71,39.21,70.7,38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M70.47,33s.15,1.42.6,1.42,5.9-3.22,9.35,1c0,0-2.17-5-8.68-2.1A.85.85,0,0,1,70.47,33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M123.59,75.14l-10.13-1.88c-4.94,8.39-14.66,20.6-28.53,18-14.73-2.8-18.24-11.93-19.05-17a9.2,9.2,0,0,0-3.33,1.16C55.68,82.41,29.6,119,29.6,119l99.6-11.35V82.27C129.2,75.67,123.59,75.14,123.59,75.14Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40.17,77.27a7.57,7.57,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16.05.24.08.24s0,0,0,0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.68,3.68,0,0,0-.26-3.31,2.11,2.11,0,0,0-1.45-1,2.22,2.22,0,0,0-1.95.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.66,3.66,0,0,0-1.2,3.1C37.77,74.13,39.19,75.46,40.17,77.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.85,79.05a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16.05.24.09.25l0,0s0,0,0,0,.27-.47.32-.55a7.57,7.57,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.69,3.69,0,0,0-1.19,3.11C48.45,75.91,49.87,77.23,50.85,79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M61.53,80.82a7.63,7.63,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.17.05.24.09.25s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89A3.71,3.71,0,0,0,67.86,74a2.13,2.13,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82A3.67,3.67,0,0,0,63.78,75a2.61,2.61,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53A3.69,3.69,0,0,0,59,76C59.13,77.68,60.55,79,61.53,80.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M72.21,82.59a7.7,7.7,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57q0,.24.09.24s0,0,0,0l0,0c.11,0,.27-.47.32-.56A8,8,0,0,1,75,83c1.46-1.46,3.2-2.32,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.12,2.12,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.65,3.65,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.69,3.69,0,0,0-1.19,3.11C69.81,79.45,71.23,80.78,72.21,82.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M82.89,84.37a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16,0,.24.09.25l0,0s0,0,0,0,.27-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.67,3.67,0,0,0-1.2,3.11C80.49,81.23,81.91,82.55,82.89,84.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M93.57,86.14a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.58s0,.23.08.24h0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.08,2.08,0,0,0-1.66.53A3.69,3.69,0,0,0,91,81.31C91.17,83,92.59,84.32,93.57,86.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M104.25,87.91a7.7,7.7,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16,0,.24.09.25l0,0,0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.67,3.67,0,0,0-1.2,3.11C101.85,84.77,103.27,86.1,104.25,87.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M114.93,89.69a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16,0,.24.09.25l0,0s0,0,0,0,.27-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C112.53,86.55,114,87.87,114.93,89.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M125.61,91.46a7.63,7.63,0,0,1,.77,2,5.4,5.4,0,0,1,.1.58c0,.16.06.23.09.24h0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.08,2.08,0,0,0-1.66.53,3.72,3.72,0,0,0-1.2,3.11C123.21,88.32,124.63,89.64,125.61,91.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M123.17,93.94a7.5,7.5,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16-.06-.24-.09-.25l0,0,0,0c-.11,0-.27.48-.32.56a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C125.57,97.08,124.15,95.76,123.17,93.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M112.49,92.17a7.63,7.63,0,0,1-.77-2,5.4,5.4,0,0,1-.1-.58c0-.16-.06-.23-.09-.24s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.05,2.05,0,0,0,1.66-.54,3.69,3.69,0,0,0,1.2-3.1C114.89,95.31,113.47,94,112.49,92.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M101.81,90.4a7.57,7.57,0,0,1-.77-2c0-.18-.08-.37-.11-.57s-.05-.24-.08-.24,0,0,0,0l0,0c-.11,0-.27.47-.32.56A8,8,0,0,1,99.07,90c-1.46,1.46-3.2,2.32-3.85,3.89a3.68,3.68,0,0,0,.26,3.31,2.05,2.05,0,0,0,1.44,1,2.19,2.19,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.66,3.66,0,0,0,1.2-3.1C104.21,93.54,102.79,92.21,101.81,90.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M91.13,88.62a7.5,7.5,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.05,2.05,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C93.53,91.76,92.11,90.44,91.13,88.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M80.45,86.85a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.58s0-.23-.08-.24,0,0,0,0,0,0,0,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.11,2.11,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.09,2.09,0,0,0,1.67-.53A3.72,3.72,0,0,0,83,91.68C82.85,90,81.43,88.67,80.45,86.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M69.77,85.08a7.7,7.7,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.24,0,0,0,0l0,0c-.11,0-.28.47-.32.56A8,8,0,0,1,67,84.68c-1.46,1.46-3.2,2.32-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.12,2.12,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64A2.06,2.06,0,0,0,71.14,93a3.7,3.7,0,0,0,1.2-3.11C72.17,88.22,70.75,86.89,69.77,85.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M59.09,83.3a7.17,7.17,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.05,2.05,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C61.49,86.44,60.07,85.12,59.09,83.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M48.41,81.53a7.24,7.24,0,0,1-.77-2c0-.18-.08-.37-.11-.57s-.05-.23-.08-.24h0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.15,2.15,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.82,3.73,3.73,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.2-3.1C50.81,84.67,49.38,83.35,48.41,81.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M37.73,79.76a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s-.05-.24-.08-.25l0,0,0,0c-.11,0-.28.47-.32.56A8,8,0,0,1,35,79.36c-1.46,1.46-3.2,2.32-3.85,3.88a3.73,3.73,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.81,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C40.13,82.9,38.71,81.57,37.73,79.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M42.78,55.29a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s.05.25.08.25,0,0,0,0,0,0,0,0,.27-.47.31-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.72,3.72,0,0,0-.25-3.33,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82A3.63,3.63,0,0,0,45,49.46a2.64,2.64,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C40.37,52.15,41.8,53.48,42.78,55.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M53.45,57.06a7.36,7.36,0,0,1,.77,2c0,.19.08.37.11.57s.05.24.08.24,0,0,0,0,0,0,0,0,.28-.47.33-.55a7.5,7.5,0,0,1,1.4-1.87C57.65,56,59.39,55.15,60,53.58a3.73,3.73,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.64,2.64,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C51.05,53.93,52.47,55.25,53.45,57.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M64.13,58.84a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a7.55,7.55,0,0,1,1.41-1.86c1.45-1.46,3.19-2.32,3.84-3.89A3.74,3.74,0,0,0,70.47,52,2.1,2.1,0,0,0,69,51a2.21,2.21,0,0,0-2,.82A3.67,3.67,0,0,0,66.38,53a2.61,2.61,0,0,0-1.95-2.63,2.1,2.1,0,0,0-1.67.53A3.74,3.74,0,0,0,61.56,54C61.73,55.7,63.15,57,64.13,58.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M74.81,60.61a7.42,7.42,0,0,1,.77,2c0,.19.08.38.11.58s0,.24.08.24,0,0,0,0,0,0,0,0,.28-.47.33-.56A7.66,7.66,0,0,1,77.55,61c1.46-1.46,3.2-2.32,3.85-3.88a3.72,3.72,0,0,0-.25-3.33,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C72.41,57.47,73.84,58.8,74.81,60.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M85.5,62.38a7.69,7.69,0,0,1,.76,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.47.31-.55a7.79,7.79,0,0,1,1.41-1.87c1.45-1.45,3.19-2.31,3.84-3.88a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.64,2.64,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C83.09,59.25,84.52,60.57,85.5,62.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M96.17,64.16a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0a0,0,0,0,0,0,0c.1,0,.27-.47.32-.56a7.45,7.45,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.65,3.65,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C93.77,61,95.2,62.34,96.17,64.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M106.86,65.93a7.76,7.76,0,0,1,.76,2c0,.19.08.38.11.58s0,.24.08.24h0s0,0,0,0,.27-.47.32-.56a7.45,7.45,0,0,1,1.4-1.86c1.45-1.46,3.2-2.31,3.85-3.88a3.76,3.76,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.82,3.82,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C104.46,62.79,105.88,64.12,106.86,65.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M117.54,67.7a7.83,7.83,0,0,1,.76,2c0,.19.08.37.11.57s0,.24.08.25l0,0,0,0c.11,0,.28-.47.33-.55a7.5,7.5,0,0,1,1.4-1.87c1.45-1.45,3.19-2.31,3.84-3.88a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.65,3.65,0,0,0-.67,1.14,2.65,2.65,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C115.13,64.57,116.56,65.89,117.54,67.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M128.22,69.48a7.62,7.62,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.16,0,.24.08.25s0,0,0,0a0,0,0,0,0,0,0c.1,0,.27-.47.31-.56A7.74,7.74,0,0,1,131,69.88c1.45-1.46,3.2-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.13,2.13,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.65,3.65,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C125.81,66.34,127.24,67.66,128.22,69.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M125.78,72a7.49,7.49,0,0,1-.77-2,5.22,5.22,0,0,1-.11-.57c0-.16-.05-.24-.08-.25l0,0s0,0,0,0-.27.46-.32.55a7.51,7.51,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.74,3.74,0,0,0,1.2-3.11C128.17,75.1,126.75,73.78,125.78,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M115.09,70.19a7.62,7.62,0,0,1-.76-2c0-.19-.08-.38-.11-.57s0-.25-.08-.25,0,0,0,0a0,0,0,0,0,0,0c-.1,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C117.49,73.33,116.07,72,115.09,70.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M104.41,68.42a7.69,7.69,0,0,1-.76-2,5.22,5.22,0,0,1-.11-.57c0-.16-.05-.24-.08-.24s0,0,0,0,0,0,0,0-.27.47-.32.55a7.56,7.56,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.84,3.88a3.72,3.72,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C106.81,71.55,105.39,70.23,104.41,68.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M93.73,66.64a8,8,0,0,1-.77-2c0-.19-.07-.38-.1-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.56A7.51,7.51,0,0,1,91,66.24c-1.45,1.46-3.2,2.32-3.85,3.89a3.73,3.73,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.18,2.18,0,0,0,2-.82,3.49,3.49,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C96.13,69.78,94.71,68.46,93.73,66.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M83.05,64.87a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.17-.05-.25-.08-.25a0,0,0,0,0,0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.76,3.76,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.45,1,2.22,2.22,0,0,0,2-.82,3.49,3.49,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.76,3.76,0,0,0,1.2-3.12C85.45,68,84,66.68,83.05,64.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M72.37,63.1a7.69,7.69,0,0,1-.76-2,5.22,5.22,0,0,1-.11-.57c0-.16,0-.24-.08-.24s0,0,0,0,0,0,0,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.84,3.88A3.7,3.7,0,0,0,66,69.9a2.11,2.11,0,0,0,1.45,1,2.22,2.22,0,0,0,2-.83,3.65,3.65,0,0,0,.67-1.14,2.64,2.64,0,0,0,2,2.64A2.09,2.09,0,0,0,73.75,71,3.73,3.73,0,0,0,75,67.92C74.77,66.23,73.35,64.91,72.37,63.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M61.69,61.32a8,8,0,0,1-.77-2c0-.19-.07-.38-.1-.57s0-.24-.08-.25,0,0,0,0,0,0,0,0-.27.47-.32.56A7.76,7.76,0,0,1,59,60.92c-1.46,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.18,2.18,0,0,0,1.95-.82,3.49,3.49,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C64.09,64.46,62.67,63.14,61.69,61.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M51,59.55a8,8,0,0,1-.77-2,5.4,5.4,0,0,1-.1-.58c0-.16,0-.24-.08-.24l0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.76,3.76,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.45,1,2.21,2.21,0,0,0,1.95-.82,3.6,3.6,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.76,3.76,0,0,0,1.2-3.12C53.41,62.69,52,61.36,51,59.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M40.33,57.78a8.08,8.08,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16-.05-.24-.08-.24s0,0,0,0,0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88A3.73,3.73,0,0,0,34,64.58a2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,1.95-.82,3.49,3.49,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C42.73,60.91,41.31,59.59,40.33,57.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M33,120.26a7.7,7.7,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57q0,.24.09.24s0,0,0,0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.45,3.2-2.31,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C30.63,117.12,32.05,118.45,33,120.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M43.71,122a7.63,7.63,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.46.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82A3.67,3.67,0,0,0,46,116.2a2.6,2.6,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53,3.71,3.71,0,0,0-1.2,3.11C41.31,118.9,42.73,120.22,43.71,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M54.39,123.81a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.25.08.25,0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.08,2.08,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53,3.68,3.68,0,0,0-1.2,3.11C52,120.67,53.41,122,54.39,123.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M65.07,125.58a7.7,7.7,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0,0,0c.11,0,.28-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-1.95-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C62.67,122.45,64.09,123.77,65.07,125.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M75.75,127.36a7.63,7.63,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16,0,.24.09.25l0,0s0,0,0,0,.28-.46.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.6,2.6,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C73.35,124.22,74.77,125.54,75.75,127.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M86.43,129.13a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.25.08.25,0,0,0,0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.1,2.1,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.92,3.92,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.08,2.08,0,0,0-1.66.53,3.73,3.73,0,0,0-1.2,3.12C84,126,85.45,127.32,86.43,129.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M97.11,130.9a7.7,7.7,0,0,1,.77,2c0,.19.08.37.11.57s.05.24.08.24,0,0,0,0l0,0c.11,0,.27-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.44-1,2.21,2.21,0,0,0-2,.83,3.67,3.67,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C94.71,127.77,96.13,129.09,97.11,130.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M107.79,132.68a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25l0,0,0,0c.11,0,.28-.47.32-.56a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.6,2.6,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C105.39,129.54,106.81,130.86,107.79,132.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M118.47,134.45a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s.05.25.08.25,0,0,0,0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.72,3.72,0,0,0-.26-3.33,2.06,2.06,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.92,3.92,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.73,3.73,0,0,0-1.2,3.12C116.07,131.31,117.49,132.64,118.47,134.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M116,136.94a7.7,7.7,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.12,2.12,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.67,3.67,0,0,0,1.2-3.11C118.43,140.07,117,138.75,116,136.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M105.35,135.16a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25,0,0,0,0,0,0,0,0-.27.46-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89A3.71,3.71,0,0,0,99,142a2.07,2.07,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53,3.68,3.68,0,0,0,1.2-3.11C107.75,138.3,106.33,137,105.35,135.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M94.67,133.39a7.77,7.77,0,0,1-.77-2,5.4,5.4,0,0,1-.1-.58q0-.24-.09-.24s0,0,0,0l0,0c-.1,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.32-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.92,3.92,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.05,2.05,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C97.07,136.52,95.65,135.2,94.67,133.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M84,131.62a7.7,7.7,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16-.05-.24-.09-.25l0,0s0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.12,2.12,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C86.39,134.75,85,133.43,84,131.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M73.31,129.84a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16-.06-.24-.09-.25s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53,3.68,3.68,0,0,0,1.2-3.11C75.71,133,74.29,131.65,73.31,129.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M62.63,128.07a7.7,7.7,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.24h0l0,0c-.11,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.32-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64A2.05,2.05,0,0,0,64,136a3.7,3.7,0,0,0,1.2-3.11C65,131.2,63.61,129.88,62.63,128.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M52,126.3a7.84,7.84,0,0,1-.77-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.05,2.05,0,0,0,1.44,1,2.18,2.18,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.64,2.09,2.09,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C54.35,129.43,52.93,128.11,52,126.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M41.27,124.52a7.63,7.63,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25,0,0,0,0,0,0,0,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14A2.61,2.61,0,0,0,41,133a2.09,2.09,0,0,0,1.67-.53,3.71,3.71,0,0,0,1.2-3.11C43.67,127.66,42.25,126.33,41.27,124.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M30.59,122.75a7.77,7.77,0,0,1-.77-2c0-.19-.08-.38-.11-.58s-.05-.24-.08-.24h0l0,0c-.11,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.32-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.11,2.11,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C33,125.88,31.57,124.56,30.59,122.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M35.63,98.28a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.58s.05.23.08.24,0,0,0,0l0,0c.11,0,.28-.47.32-.56a7.74,7.74,0,0,1,1.41-1.86c1.45-1.46,3.2-2.32,3.84-3.89A3.7,3.7,0,0,0,42,91.47a2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.71,3.71,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C33.23,95.14,34.66,96.46,35.63,98.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M46.31,100.05a7.36,7.36,0,0,1,.77,2c0,.18.08.37.11.57s.05.24.08.25,0,0,0,0l0,0c.11,0,.28-.47.33-.56a7.66,7.66,0,0,1,1.39-1.86c1.46-1.46,3.21-2.31,3.85-3.88a3.7,3.7,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.23,2.23,0,0,0-2,.81,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C43.91,96.92,45.34,98.24,46.31,100.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M57,101.83a7.62,7.62,0,0,1,.76,2c0,.19.08.38.11.57s.05.24.08.25l0,0s0,0,0,0,.27-.48.32-.56a7.45,7.45,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89A3.74,3.74,0,0,0,63.33,95a2.1,2.1,0,0,0-1.45-1,2.18,2.18,0,0,0-2,.82A3.49,3.49,0,0,0,59.25,96a2.65,2.65,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54A3.73,3.73,0,0,0,54.42,97C54.6,98.69,56,100,57,101.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M67.68,103.6a7.55,7.55,0,0,1,.76,2c0,.18.08.37.11.57s0,.23.08.24,0,0,0,0,0,0,0,0,.27-.47.32-.56a7.7,7.7,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.84-3.89A3.7,3.7,0,0,0,74,96.79a2.13,2.13,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.54,3.54,0,0,0-.68,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C65.27,100.46,66.7,101.79,67.68,103.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M78.36,105.38a7.48,7.48,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.16,0,.24.08.25l0,0s0,0,0,0,.27-.47.32-.55a7.56,7.56,0,0,1,1.4-1.87c1.45-1.46,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.2,2.2,0,0,0-1.95.81,3.65,3.65,0,0,0-.68,1.15,2.64,2.64,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C76,102.24,77.38,103.56,78.36,105.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M89,107.15a7.62,7.62,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16,0,.23.08.24a0,0,0,0,0,0,0s0,0,0,0,.27-.47.32-.56a7.45,7.45,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.84-3.89a3.7,3.7,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.86,3.86,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.73,3.73,0,0,0-1.2,3.11C86.63,104,88.06,105.33,89,107.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M99.72,108.92a7.69,7.69,0,0,1,.76,2,4.8,4.8,0,0,1,.11.57c0,.16,0,.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a7.7,7.7,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.82,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C97.32,105.78,98.74,107.11,99.72,108.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M110.4,110.7a7.48,7.48,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.16,0,.24.08.25a.05.05,0,0,0,0,0s0,0,0,0,.27-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.81,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.15,2.15,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C108,107.56,109.42,108.88,110.4,110.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M121.08,112.47a7.62,7.62,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16,0,.23.08.24l0,0s0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.19,2.19,0,0,0-1.95.82,3.44,3.44,0,0,0-.68,1.15,2.66,2.66,0,0,0-2-2.65,2.16,2.16,0,0,0-1.67.54,3.75,3.75,0,0,0-1.2,3.11C118.68,109.33,120.1,110.65,121.08,112.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M118.64,115a7.17,7.17,0,0,1-.77-2c0-.19-.08-.38-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a7.55,7.55,0,0,1-1.41,1.86c-1.45,1.46-3.19,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.81,3.63,3.63,0,0,0,.67-1.15,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C121,118.09,119.61,116.77,118.64,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M108,113.18a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.58s0-.23-.08-.24l0,0s0,0,0,0-.28.47-.33.56a7.45,7.45,0,0,1-1.4,1.86c-1.45,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.42,3.42,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C110.36,116.32,108.93,115,108,113.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M97.28,111.41a7.24,7.24,0,0,1-.77-2,4.8,4.8,0,0,1-.11-.57c0-.16-.05-.24-.08-.24s0,0,0,0l0,0c-.1,0-.27.47-.32.56A7.66,7.66,0,0,1,94.54,111c-1.46,1.46-3.21,2.32-3.85,3.88a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.81,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C99.68,114.55,98.25,113.22,97.28,111.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M86.6,109.63a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0a0,0,0,0,0,0,0c-.1,0-.27.48-.32.56a7.93,7.93,0,0,1-1.39,1.86c-1.46,1.46-3.21,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C89,112.77,87.57,111.45,86.6,109.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M75.92,107.86a7.24,7.24,0,0,1-.77-2,4.8,4.8,0,0,1-.11-.57c0-.16-.05-.23-.08-.24s0,0,0,0,0,0,0,0-.27.47-.32.56a7.7,7.7,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.37,3.37,0,0,0,.68-1.15,2.64,2.64,0,0,0,2,2.64,2.11,2.11,0,0,0,1.67-.53,3.75,3.75,0,0,0,1.2-3.11C78.31,111,76.89,109.68,75.92,107.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M65.23,106.09a7.69,7.69,0,0,1-.76-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a7.32,7.32,0,0,1-1.4,1.87c-1.45,1.46-3.2,2.32-3.84,3.88a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.81,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C67.63,109.23,66.21,107.9,65.23,106.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M54.55,104.31a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.17,0-.24-.08-.25l0,0a0,0,0,0,0,0,0c-.1,0-.27.48-.32.56a7.45,7.45,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.73,3.73,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.18,2.18,0,0,0,1.95-.82,3.49,3.49,0,0,0,.68-1.14,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C57,107.45,55.53,106.13,54.55,104.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M43.87,102.54a7.55,7.55,0,0,1-.76-2A4.8,4.8,0,0,1,43,100c0-.16,0-.24-.08-.24h0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.71,3.71,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.75,3.75,0,0,0,1.2-3.11C46.28,105.68,44.85,104.35,43.87,102.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M33.2,100.77a7.36,7.36,0,0,1-.77-2,4.8,4.8,0,0,1-.11-.57c0-.16,0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.33-3.84,3.89a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.81,3.65,3.65,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.12,2.12,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C35.59,103.9,34.17,102.58,33.2,100.77Z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M81,46.36a4.67,4.67,0,1,1-4.67-4.66A4.67,4.67,0,0,1,81,46.36Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.87,37.45S71.54,36,74,35.7,72.37,35.78,71.87,37.45Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M68.09,53.25l.6-1.59,2.35.08A4.06,4.06,0,0,1,68.09,53.25Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M67.89,50.06a3.65,3.65,0,0,0,.53-.24s2.07.8,2.62,1.92l-2.35-.08Z"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 58,
    height: 61,
    transform: "translate(68.23 15.5)",
    xlinkHref: "data:image/png;base64,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"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.88,118.58,47.5,116.9l-1-4a15.41,15.41,0,0,1,.42-5.79c.24-.73-1.69-1.58-2.53,1.7l-1,3-.84-8.32s-.26-4.77-1.41-3.82c-.73.59-1.1,2.94-.95,3.64s-.37,7.3-.37,7.3l-.95-6.48s-.51-5-1.12-4.85c-2.29.52-1.73,3.58-1.54,4.39s.58,7.64.58,7.64l-2.17-7.59s-.53-3.2-1.18-2.82c-1.56.93-1.11,3.11-1,3.53.2.77,1.45,6.8,1.45,6.8l-1.11-1.45S30.38,104.65,30,105c-1.75,1.5,2.21,11,2.21,11A22.53,22.53,0,0,0,32.88,118.58Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M102.89,70.84a2.34,2.34,0,0,1,.37.54.77.77,0,0,1,.07.16s0,.07,0,.07h0s0-.16.06-.19a2.57,2.57,0,0,1,.28-.66c.33-.53.79-.92.87-1.43a1.16,1.16,0,0,0-.32-1,.65.65,0,0,0-.5-.19.69.69,0,0,0-.52.38,1.27,1.27,0,0,0-.12.39.79.79,0,0,0-.77-.64.67.67,0,0,0-.46.28,1.13,1.13,0,0,0-.13,1C102,70.08,102.47,70.37,102.89,70.84Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M102.55,67.47a2.34,2.34,0,0,1,.37.54.77.77,0,0,1,.07.16s0,.07.05.07h0s0-.16,0-.19a2.57,2.57,0,0,1,.28-.66c.33-.54.79-.91.87-1.43a1.15,1.15,0,0,0-.31-1,.66.66,0,0,0-.5-.19.68.68,0,0,0-.53.39,1.13,1.13,0,0,0-.12.38.79.79,0,0,0-.77-.64.67.67,0,0,0-.46.28,1.13,1.13,0,0,0-.13,1C101.61,66.71,102.13,67,102.55,67.47Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M102.21,64.1a2.37,2.37,0,0,1,.38.54l.07.16s0,.07,0,.07a0,0,0,0,0,0,0h0s0-.16.06-.19a2.38,2.38,0,0,1,.28-.66c.33-.53.78-.91.86-1.43a1.12,1.12,0,0,0-.31-1,.65.65,0,0,0-.5-.19.67.67,0,0,0-.52.38.89.89,0,0,0-.12.39.81.81,0,0,0-.78-.64.63.63,0,0,0-.45.28,1.13,1.13,0,0,0-.14,1C101.28,63.34,101.79,63.63,102.21,64.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M101.88,60.73a2.34,2.34,0,0,1,.37.54,1.11,1.11,0,0,1,.07.16s0,.07,0,.07h0s.05-.16.06-.19a2.73,2.73,0,0,1,.28-.66c.33-.53.79-.91.87-1.43a1.16,1.16,0,0,0-.32-1,.67.67,0,0,0-.5-.19.68.68,0,0,0-.52.39,1.13,1.13,0,0,0-.12.38.79.79,0,0,0-.77-.64.63.63,0,0,0-.46.28,1.13,1.13,0,0,0-.13,1C100.94,60,101.46,60.26,101.88,60.73Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M101.54,57.36a2.34,2.34,0,0,1,.37.54,1.11,1.11,0,0,1,.07.16s0,.07,0,.07h0s0-.16,0-.19a2.73,2.73,0,0,1,.28-.66c.33-.53.79-.91.87-1.43a1.15,1.15,0,0,0-.31-1,.62.62,0,0,0-1,.2,1.12,1.12,0,0,0-.12.39.79.79,0,0,0-.77-.65.67.67,0,0,0-.46.28,1.13,1.13,0,0,0-.13,1C100.6,56.6,101.12,56.89,101.54,57.36Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M101.2,54a2.34,2.34,0,0,1,.37.54l.08.16c0,.05,0,.07,0,.07h0s.05-.16.05-.19a2.23,2.23,0,0,1,.29-.65c.33-.54.78-.92.86-1.44a1.12,1.12,0,0,0-.31-1,.68.68,0,0,0-.5-.19.66.66,0,0,0-.52.39.81.81,0,0,0-.12.39.82.82,0,0,0-.78-.65.63.63,0,0,0-.45.28,1.14,1.14,0,0,0-.14,1C100.27,53.23,100.78,53.52,101.2,54Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M100.87,50.62a2.7,2.7,0,0,1,.37.54l.07.16s0,.07,0,.07h0s0-.16.06-.19a2.51,2.51,0,0,1,.28-.65c.33-.54.79-.92.87-1.44a1.13,1.13,0,0,0-.32-1,.64.64,0,0,0-.5-.2.66.66,0,0,0-.52.39,1.12,1.12,0,0,0-.12.39.81.81,0,0,0-.77-.65.65.65,0,0,0-.46.28,1.13,1.13,0,0,0-.13,1C99.93,49.86,100.45,50.15,100.87,50.62Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M100.47,47.36a2.24,2.24,0,0,1,.48.45l.1.14s0,.06,0,.06h0s0-.16,0-.19a2.35,2.35,0,0,1,.14-.7c.22-.59.59-1.06.56-1.58a1.15,1.15,0,0,0-.5-.88.66.66,0,0,0-.54-.09.68.68,0,0,0-.43.48,1.36,1.36,0,0,0,0,.41.81.81,0,0,0-.88-.48.65.65,0,0,0-.39.37,1.12,1.12,0,0,0,.07,1C99.4,46.8,100,47,100.47,47.36Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M99.46,44.12a2.27,2.27,0,0,1,.47.46,1.71,1.71,0,0,1,.11.14s0,.06,0,.06h0s0-.16,0-.19a2.37,2.37,0,0,1,.15-.7c.21-.6.58-1.06.56-1.58a1.15,1.15,0,0,0-.51-.89.63.63,0,0,0-.53-.08.68.68,0,0,0-.43.48,1.1,1.1,0,0,0,0,.41.8.8,0,0,0-.89-.48.67.67,0,0,0-.39.37,1.15,1.15,0,0,0,.08,1C98.38,43.57,99,43.75,99.46,44.12Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M98.45,40.89a2.54,2.54,0,0,1,.47.46l.1.14s0,.06.06.06h0s0-.16,0-.19a2,2,0,0,1,.15-.7c.21-.6.58-1.06.55-1.58a1.14,1.14,0,0,0-.5-.89.63.63,0,0,0-.53-.08.69.69,0,0,0-.44.48,1.34,1.34,0,0,0,0,.41.81.81,0,0,0-.89-.48.65.65,0,0,0-.39.37,1.15,1.15,0,0,0,.07,1C97.37,40.34,97.94,40.52,98.45,40.89Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M97.43,37.66a2.49,2.49,0,0,1,.47.45l.11.15s0,.06,0,.06h0s0-.17,0-.2a2.29,2.29,0,0,1,.14-.69,4.71,4.71,0,0,0,.56-1.58,1.15,1.15,0,0,0-.5-.89.63.63,0,0,0-1,.4,1,1,0,0,0,0,.4.8.8,0,0,0-.88-.47.62.62,0,0,0-.39.37,1.1,1.1,0,0,0,.07,1C96.36,37.11,96.92,37.29,97.43,37.66Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M96.42,34.43a2.49,2.49,0,0,1,.47.45A1.3,1.3,0,0,1,97,35l.06.06s0,0,0,0h0s0-.17,0-.2a2.65,2.65,0,0,1,.15-.69c.21-.6.58-1.06.56-1.58a1.16,1.16,0,0,0-.51-.89.63.63,0,0,0-.53-.08.66.66,0,0,0-.43.48,1,1,0,0,0,0,.4.81.81,0,0,0-.89-.47.65.65,0,0,0-.39.37,1.13,1.13,0,0,0,.08,1C95.34,33.88,95.91,34.06,96.42,34.43Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M94.87,31.58a2.18,2.18,0,0,1,.58.31l.14.11s0,0,.06,0h0s0-.16,0-.19a2.44,2.44,0,0,1,0-.71,4.68,4.68,0,0,0,.11-1.67,1.12,1.12,0,0,0-.72-.72.61.61,0,0,0-.53.06.65.65,0,0,0-.29.58,1,1,0,0,0,.07.4.8.8,0,0,0-1-.22A.62.62,0,0,0,93,30a1.17,1.17,0,0,0,.34,1C93.69,31.33,94.28,31.35,94.87,31.58Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M93,28.74a2.18,2.18,0,0,1,.58.31l.14.11.07,0h0s0-.17,0-.2a2.11,2.11,0,0,1,0-.71,4.69,4.69,0,0,0,.12-1.67,1.16,1.16,0,0,0-.73-.72.65.65,0,0,0-.53.06.67.67,0,0,0-.29.58,1.12,1.12,0,0,0,.07.4.8.8,0,0,0-1-.22.64.64,0,0,0-.28.46,1.15,1.15,0,0,0,.34,1C91.85,28.49,92.44,28.51,93,28.74Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M91.35,25.93a2.18,2.18,0,0,1,.65.12l.16.06s.07,0,.08,0h0s0,0,0,0-.08-.14-.09-.17a2.36,2.36,0,0,1-.27-.66c-.15-.61-.09-1.21-.4-1.63a1.18,1.18,0,0,0-.91-.46.64.64,0,0,0-.49.23.68.68,0,0,0-.1.64,1.57,1.57,0,0,0,.19.36.8.8,0,0,0-1,.09.67.67,0,0,0-.12.52,1.14,1.14,0,0,0,.62.81A4.72,4.72,0,0,0,91.35,25.93Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M88.72,23.79a3.08,3.08,0,0,1,.65.12l.17.06s.07,0,.07,0,0,0,0,0h0s-.07-.15-.09-.18a2.22,2.22,0,0,1-.26-.66,4.63,4.63,0,0,0-.41-1.62,1.12,1.12,0,0,0-.91-.46.64.64,0,0,0-.49.22.66.66,0,0,0-.09.64,1,1,0,0,0,.19.36.8.8,0,0,0-1,.09.64.64,0,0,0-.13.52,1.16,1.16,0,0,0,.62.81A4.72,4.72,0,0,0,88.72,23.79Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M86.05,22a2.32,2.32,0,0,1,.65-.07l.18,0c.05,0,.08,0,.08,0h0s-.12-.12-.14-.14a2.18,2.18,0,0,1-.44-.56c-.31-.55-.43-1.13-.84-1.45a1.15,1.15,0,0,0-1-.19.63.63,0,0,0-.41.35.68.68,0,0,0,.08.64,1.37,1.37,0,0,0,.29.3.8.8,0,0,0-.94.36.68.68,0,0,0,0,.54,1.13,1.13,0,0,0,.82.6C84.94,22.43,85.44,22.11,86.05,22Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M87,27.3S82.5,20,74.84,18.59c-5.63-1-5.71-3.54-5.71-3.54s-2,6.92-1.92,10.17C67.21,25.22,76.21,21,87,27.3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M70.35,22.49a3,3,0,0,1,.45.72,1.8,1.8,0,0,1,.08.21c0,.06,0,.09.05.09s0,0,0,0h0s.07-.2.08-.24a3.18,3.18,0,0,1,.4-.83c.46-.67,1.07-1.14,1.2-1.79a1.46,1.46,0,0,0-.35-1.27.82.82,0,0,0-.64-.28.86.86,0,0,0-.69.46,1.36,1.36,0,0,0-.18.5,1,1,0,0,0-1-.88.85.85,0,0,0-.61.33,1.47,1.47,0,0,0-.23,1.3C69.18,21.45,69.83,21.86,70.35,22.49Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M74.45,22.38a2.55,2.55,0,0,1,.31.69,1.46,1.46,0,0,1,0,.2c0,.06,0,.08,0,.09h0s.08-.17.09-.21a3.13,3.13,0,0,1,.46-.68c.49-.54,1.09-.87,1.28-1.44a1.31,1.31,0,0,0-.15-1.17.77.77,0,0,0-.53-.32.81.81,0,0,0-.68.33,1.22,1.22,0,0,0-.21.41.93.93,0,0,0-.75-.89.7.7,0,0,0-.57.22,1.28,1.28,0,0,0-.36,1.12C73.54,21.32,74.07,21.76,74.45,22.38Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M78,22.85a1.9,1.9,0,0,1,.14.51c0,.05,0,.1,0,.15s0,0,0,.06h0s.08-.11.09-.13a2,2,0,0,1,.4-.42c.39-.32.85-.49,1-.86a.9.9,0,0,0,0-.83.49.49,0,0,0-.33-.28.52.52,0,0,0-.5.15,1.06,1.06,0,0,0-.2.26.65.65,0,0,0-.42-.7.54.54,0,0,0-.42.09.94.94,0,0,0-.38.74A4.06,4.06,0,0,0,78,22.85Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M81.13,23.72a1.27,1.27,0,0,1,.05.34.31.31,0,0,0,0,.1v0h0s.06-.06.07-.07a1.28,1.28,0,0,1,.29-.24c.29-.17.59-.24.75-.46a.6.6,0,0,0,.09-.53.36.36,0,0,0-.19-.21.35.35,0,0,0-.34,0,.78.78,0,0,0-.15.16.43.43,0,0,0-.2-.49.31.31,0,0,0-.28,0,.59.59,0,0,0-.31.44A2.74,2.74,0,0,0,81.13,23.72Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M88.81,80.84a7.37,7.37,0,0,1-2.53-.44c-6.41-2.33-5.64-9-5.63-9.12l.15-.12c0,.07-.36,6.51,5.66,8.7s12-5.26,12-5.34l.42.36C98.69,75.16,94.18,80.84,88.81,80.84Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M85.1,85.67a4.64,4.64,0,0,1,.35,1.23,1.87,1.87,0,0,1,0,.34c0,.1,0,.14,0,.15s0,0,0,0,0,0,0,0,.19-.27.22-.32a4.8,4.8,0,0,1,.93-1c.94-.79,2-1.21,2.5-2.1a2.21,2.21,0,0,0,0-2,1.25,1.25,0,0,0-.81-.67,1.35,1.35,0,0,0-1.21.38,2.24,2.24,0,0,0-.46.65,1.56,1.56,0,0,0-1-1.67,1.23,1.23,0,0,0-1,.23,2.22,2.22,0,0,0-.88,1.78C83.84,83.67,84.62,84.54,85.1,85.67Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M123.86,74.88,101,71A101,101,0,0,0,81.7,113l34.75-4S113.26,89.56,123.86,74.88Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M106.7,71.7S92.2,91,90.7,112l6.5-.75S101,84.48,113.73,73Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90,39.47s1,12-5,12.75C85,52.22,94.21,55.22,90,39.47Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M35.08,104.94S32,89.42,39.77,76.1l.65.52s-7.46,9.16-4.5,29.09Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M39.78,74.23s0-3.81-.45-4.4c0,0,.63-2.11,2.05-2.28,0,0,2,2,1.33,3.21A22.86,22.86,0,0,1,39.78,74.23Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M39.69,73.89s-1.16-5.58,3.47-6l3.2,1.27a3.3,3.3,0,0,1-.8,4.64C42.89,75.92,39.42,76.42,39.69,73.89Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M40.51,74.86s6.78.7,7.74-1.16-2.14-4.13-3.63-3.18S38.76,73.61,40.51,74.86Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M39,66.54s-3.35,8.6,3.2,9.46a15.19,15.19,0,0,0,6.58-.85s-1.43-4.56-6.58-2.36-1.47,1.94-1.47,1.94S40.58,68.9,39,66.54Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M39.11,74.48s2.2-1.08,3.6-.76,3.14,1.27,2.87,1.77a2,2,0,0,1-1.73.83A6.87,6.87,0,0,1,39.11,74.48Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M36.26,91.1s2.66-4.33,6.5-5.16C42.76,85.94,41.42,91.1,36.26,91.1Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94,110.1a2.38,2.38,0,0,1,.16.61.88.88,0,0,1,0,.17s0,.07,0,.07h0s.1-.13.11-.15a2.44,2.44,0,0,1,.46-.5c.47-.39,1-.59,1.24-1a1.09,1.09,0,0,0,0-1,.61.61,0,0,0-.39-.33.64.64,0,0,0-.59.19,1,1,0,0,0-.23.31.78.78,0,0,0-.5-.82.61.61,0,0,0-.5.11,1.1,1.1,0,0,0-.44.87C93.34,109.12,93.72,109.55,94,110.1Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.7,106.94a2.39,2.39,0,0,1,.17.61s0,.11,0,.17,0,.07,0,.07h0s.09-.13.11-.16a2.19,2.19,0,0,1,.46-.5c.47-.39,1-.59,1.23-1a1.09,1.09,0,0,0,0-1,.59.59,0,0,0-1-.14,1,1,0,0,0-.23.31.76.76,0,0,0-.49-.82.63.63,0,0,0-.51.11,1.06,1.06,0,0,0-.43.87C94.09,106,94.47,106.39,94.7,106.94Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.45,103.79a2.21,2.21,0,0,1,.17.6s0,.11,0,.17,0,.07,0,.07h0s.09-.13.11-.16a2,2,0,0,1,.46-.5c.47-.38,1-.59,1.23-1a1.07,1.07,0,0,0,0-1,.6.6,0,0,0-.4-.33.64.64,0,0,0-.59.18,1,1,0,0,0-.23.32.77.77,0,0,0-.5-.83.61.61,0,0,0-.5.11,1.1,1.1,0,0,0-.44.88A4.65,4.65,0,0,0,95.45,103.79Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.2,100.63a2.21,2.21,0,0,1,.17.6c0,.06,0,.11,0,.17s0,.07,0,.08h0s0,0,0,0,.09-.13.11-.15a2,2,0,0,1,.46-.51c.46-.38,1-.59,1.23-1a1.1,1.1,0,0,0,0-1,.62.62,0,0,0-.4-.33.64.64,0,0,0-.59.18A1.09,1.09,0,0,0,97,99a.79.79,0,0,0-.5-.83.65.65,0,0,0-.5.11,1.12,1.12,0,0,0-.44.88C95.58,99.65,96,100.07,96.2,100.63Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97,97.47a2.63,2.63,0,0,1,.16.6c0,.06,0,.12,0,.17a.38.38,0,0,0,0,.08h0s.1-.13.11-.15a2.79,2.79,0,0,1,.46-.51c.47-.38,1-.58,1.23-1a1.09,1.09,0,0,0,0-1,.58.58,0,0,0-.39-.33.64.64,0,0,0-.6.19.87.87,0,0,0-.22.31.77.77,0,0,0-.5-.82.57.57,0,0,0-.5.11,1.07,1.07,0,0,0-.44.87C96.33,96.49,96.71,96.91,97,97.47Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.69,94.31a2.28,2.28,0,0,1,.17.61s0,.11,0,.17,0,.07,0,.07h0S98,95,98,95a2.19,2.19,0,0,1,.46-.5c.47-.39,1-.59,1.23-1a1.09,1.09,0,0,0,0-1,.63.63,0,0,0-.39-.33.66.66,0,0,0-.6.19,1,1,0,0,0-.23.31.76.76,0,0,0-.5-.82.62.62,0,0,0-.5.11,1.1,1.1,0,0,0-.44.87C97.08,93.33,97.46,93.76,97.69,94.31Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.78,91.18a2.11,2.11,0,0,1,0,.62,1,1,0,0,1,0,.17s0,.07,0,.08h0s.12-.11.14-.13a2.68,2.68,0,0,1,.56-.39c.54-.27,1.11-.34,1.43-.72a1.1,1.1,0,0,0,.24-.95.62.62,0,0,0-.31-.41.66.66,0,0,0-.62.05,1.13,1.13,0,0,0-.29.25.77.77,0,0,0-.3-.91.63.63,0,0,0-.52,0,1.11,1.11,0,0,0-.62.76A4.37,4.37,0,0,0,98.78,91.18Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.22,88.27a2.59,2.59,0,0,1,0,.63l0,.16s0,.08,0,.08h0s.12-.11.14-.13a2.31,2.31,0,0,1,.56-.38c.54-.27,1.11-.35,1.44-.73a1.11,1.11,0,0,0,.24-.94.64.64,0,0,0-.32-.41.66.66,0,0,0-.62,0,1.16,1.16,0,0,0-.29.26.78.78,0,0,0-.3-.92.61.61,0,0,0-.51,0,1.09,1.09,0,0,0-.63.75A4.6,4.6,0,0,0,100.22,88.27Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.66,85.36a2.19,2.19,0,0,1,0,.63,1.22,1.22,0,0,1,0,.17s0,.07,0,.07h0s.12-.1.14-.12a2.22,2.22,0,0,1,.57-.39c.54-.27,1.1-.35,1.43-.72a1.1,1.1,0,0,0,.24-1,.6.6,0,0,0-.93-.37,1.22,1.22,0,0,0-.3.26.78.78,0,0,0-.3-.92.61.61,0,0,0-.51,0,1.07,1.07,0,0,0-.62.75A4.49,4.49,0,0,0,101.66,85.36Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.1,82.46a2.1,2.1,0,0,1,0,.62c0,.06,0,.11,0,.17s0,.07,0,.08h0s.12-.1.15-.12a2,2,0,0,1,.56-.39c.54-.27,1.1-.34,1.43-.72a1.1,1.1,0,0,0,.24-.95.62.62,0,0,0-.31-.41.66.66,0,0,0-.62.05,1.18,1.18,0,0,0-.3.25.75.75,0,0,0-.3-.91.6.6,0,0,0-.51,0,1.07,1.07,0,0,0-.62.75A4.58,4.58,0,0,0,103.1,82.46Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.55,79.55a2.13,2.13,0,0,1,0,.62.88.88,0,0,1,0,.17s0,.07,0,.08h0a0,0,0,0,0,0,0s.12-.11.14-.13a2.13,2.13,0,0,1,.56-.38c.54-.27,1.11-.35,1.43-.73a1.08,1.08,0,0,0,.24-.94.6.6,0,0,0-.31-.41.63.63,0,0,0-.62,0,.89.89,0,0,0-.29.26.78.78,0,0,0-.3-.92.63.63,0,0,0-.52,0,1.11,1.11,0,0,0-.62.76A4.37,4.37,0,0,0,104.55,79.55Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.26,76.74a2.2,2.2,0,0,1-.05.62,1,1,0,0,1,0,.17s0,.07,0,.07h0s.13-.09.16-.1a2.31,2.31,0,0,1,.6-.32,4.53,4.53,0,0,0,1.51-.54,1.08,1.08,0,0,0,.35-.92.62.62,0,0,0-.25-.44.67.67,0,0,0-.63,0,1.08,1.08,0,0,0-.32.22.77.77,0,0,0-.19-1,.63.63,0,0,0-.51-.06,1,1,0,0,0-.7.67A4.42,4.42,0,0,0,106.26,76.74Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108,74a2.22,2.22,0,0,1-.05.62c0,.06,0,.11,0,.17s0,.07,0,.07h0s0,0,0,0,.13-.09.15-.11a2.44,2.44,0,0,1,.6-.31c.58-.2,1.14-.21,1.51-.55a1.05,1.05,0,0,0,.35-.91.62.62,0,0,0-.25-.44.67.67,0,0,0-.63,0,1.08,1.08,0,0,0-.32.22.77.77,0,0,0-.19-1,.58.58,0,0,0-.5-.07,1.14,1.14,0,0,0-.72.67A4.75,4.75,0,0,0,108,74Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.16,73.94s1.18,15,22.55,17.28L88.3,92s-22.71-1.25-23-18Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M85.36,110.21a4,4,0,0,1,.3,1.18c0,.11,0,.22,0,.33a.36.36,0,0,0,0,.15s0,0,0,0,0,0,0,0,.18-.25.21-.3a4.61,4.61,0,0,1,.9-1c.91-.73,1.94-1.11,2.4-2a2.15,2.15,0,0,0,.07-1.9,1.2,1.2,0,0,0-.74-.66,1.24,1.24,0,0,0-1.15.33A2.36,2.36,0,0,0,87,107a1.51,1.51,0,0,0-.92-1.63,1.15,1.15,0,0,0-1,.2,2.11,2.11,0,0,0-.87,1.69C84.23,108.26,84.93,109.11,85.36,110.21Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M86.91,104.06a4.94,4.94,0,0,1,.3,1.19c0,.11,0,.22,0,.33s0,.14,0,.15h0l0,0c.06,0,.18-.25.21-.3a4.61,4.61,0,0,1,.9-1c.9-.73,1.93-1.11,2.39-2a2.17,2.17,0,0,0,.07-1.91,1.2,1.2,0,0,0-.74-.66,1.25,1.25,0,0,0-1.14.34,2,2,0,0,0-.45.61,1.52,1.52,0,0,0-.93-1.63,1.13,1.13,0,0,0-1,.2,2.14,2.14,0,0,0-.87,1.69C85.77,102.12,86.48,103,86.91,104.06Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M88.72,97.87a4.44,4.44,0,0,1,.1,1.22l0,.34c0,.09,0,.13,0,.14s0,0,0,0,0,0,0,0,.22-.22.26-.26a4.51,4.51,0,0,1,1-.8c1-.56,2.09-.76,2.69-1.51a2.2,2.2,0,0,0,.38-1.87,1.18,1.18,0,0,0-.62-.78,1.21,1.21,0,0,0-1.18.14,1.92,1.92,0,0,0-.55.52,1.52,1.52,0,0,0-.64-1.77,1.16,1.16,0,0,0-1,0,2.09,2.09,0,0,0-1.13,1.52C87.92,95.76,88.48,96.72,88.72,97.87Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M91.26,92.09a4.38,4.38,0,0,1,.1,1.22l0,.33c0,.09,0,.14,0,.15s0,0,0,0,0,0,0,0,.22-.21.25-.25a4.24,4.24,0,0,1,1-.8c1-.57,2.09-.76,2.69-1.52a2.16,2.16,0,0,0,.38-1.87,1.2,1.2,0,0,0-.62-.78,1.23,1.23,0,0,0-1.18.14,2.07,2.07,0,0,0-.55.52,1.5,1.5,0,0,0-.64-1.76,1.13,1.13,0,0,0-1,0A2.15,2.15,0,0,0,90.63,89C90.46,90,91,90.93,91.26,92.09Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M93.88,86.26a5,5,0,0,1,0,1.22c0,.11,0,.22-.07.33s0,.14,0,.15h0s0,0,0,0,.24-.2.28-.23a4.32,4.32,0,0,1,1.11-.7c1.07-.47,2.15-.57,2.82-1.27A2.16,2.16,0,0,0,98.58,84a1.17,1.17,0,0,0-.55-.83,1.23,1.23,0,0,0-1.19,0,2.14,2.14,0,0,0-.59.47,1.5,1.5,0,0,0-.48-1.81,1.12,1.12,0,0,0-1-.07,2.1,2.1,0,0,0-1.26,1.41C93.27,84.08,93.74,85.09,93.88,86.26Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M96.92,80.73a4.23,4.23,0,0,1,0,1.23c0,.1,0,.21-.06.32s0,.14,0,.15h0a0,0,0,0,1,0,0c.06,0,.24-.19.28-.23a4.67,4.67,0,0,1,1.12-.7c1.06-.47,2.15-.56,2.81-1.26a2.19,2.19,0,0,0,.55-1.83,1.2,1.2,0,0,0-.55-.83,1.23,1.23,0,0,0-1.19,0,2,2,0,0,0-.59.47,1.53,1.53,0,0,0-.48-1.82,1.19,1.19,0,0,0-1-.07,2.11,2.11,0,0,0-1.27,1.41C96.31,78.56,96.79,79.56,96.92,80.73Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M100.11,75.24a4.64,4.64,0,0,1-.08,1.22,3,3,0,0,1-.08.32c0,.09,0,.14,0,.15h0s0,0,0,0,.25-.18.29-.21a4.33,4.33,0,0,1,1.15-.64c1.08-.41,2.17-.45,2.87-1.11a2.17,2.17,0,0,0,.64-1.79,1.15,1.15,0,0,0-.51-.86,1.2,1.2,0,0,0-1.19,0,2.2,2.2,0,0,0-.61.43,1.51,1.51,0,0,0-.39-1.84,1.17,1.17,0,0,0-1-.11,2.11,2.11,0,0,0-1.34,1.33C99.61,73,100,74.06,100.11,75.24Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.84,96.34s9.75,3.25,14.5,19.25h1.25S60.34,101,46.71,95.22Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.71,93s11.3,3.68,16.8,21.84H67s-1.45-16.6-17.24-23.12Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M124.34,75.22s-10.75,15.12-7.5,33.62l-1.38.13s-3-20.53,8.13-33.83l.27-.26"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.45,168.22l-.09-15.33s-8.75-.25-10,4.75S84.45,168.22,84.45,168.22Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 73.61,
    y: 148.14,
    width: 7.5,
    height: 18.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.21,193.11s6.78,7.17,0,8.77c0,0,1.6,5.18-8.37,6.78s-48.25,8-45.06-59.42l27.51,3.19,10.77,23.13Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.45,154.23s12.23,12.16,11.83,25.32,7.18,27.91,21.54,19.14l.63-7.47,3-10-3-1.33.23-3.61-.8-1.6.6-1.59a12.11,12.11,0,0,1-1-1.4c-.24-.44,2-6.3-1.7-6.3-5.11,0-9.67.17-10.29-2.71-1-4.4-2.28-7,1-7.79,13-3,14.33-3,14.33-3s8.2-28.57-22.5-30.57-35.9,27.52-35.9,27.52Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.87,188.32a4.13,4.13,0,0,0-2.49.05c-1.89.61-4.1,1.94-5.6-.23l1.25.42a3.42,3.42,0,0,0,2.28-.84s-.22-1.94,1.35-1.87a1.2,1.2,0,0,1,1.19,1.57S87.57,187.12,87.87,188.32Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.1,193.33s-.15-1.42-.6-1.42-5.91,3.22-9.35-1c0,0,2.17,5,8.68,2.1A.85.85,0,0,1,88.1,193.33Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M35,151.2l10.13,1.88c4.94-8.39,14.66-20.6,28.52-18,14.74,2.8,18.25,11.93,19.05,17A9,9,0,0,0,96,150.94c6.87-7,33-43.57,33-43.57L29.37,118.72v25.35C29.37,150.67,35,151.2,35,151.2Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M118.4,149.07a7.7,7.7,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0,0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.25,3.31,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,1.95,2.64,2.06,2.06,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C120.8,152.21,119.38,150.88,118.4,149.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M107.72,147.29a7.5,7.5,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.47-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.09,2.09,0,0,0,1.45,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.64,2.64,0,0,0,2,2.64,2.13,2.13,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C110.12,150.43,108.7,149.11,107.72,147.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M97,145.52a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25,0,0,0,0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.09,2.09,0,0,0,1.44,1,2.24,2.24,0,0,0,2-.82,3.79,3.79,0,0,0,.68-1.14A2.61,2.61,0,0,0,96.74,154a2.06,2.06,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.2-3.1C99.44,148.66,98,147.34,97,145.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M86.36,143.75a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0,0,0c-.11,0-.28.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.26,2.26,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C88.76,146.89,87.34,145.56,86.36,143.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M75.68,142a7.17,7.17,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C78.08,145.11,76.65,143.79,75.68,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M65,140.2a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.58s-.05-.23-.08-.24h0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.82,3.73,3.73,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.75,3.75,0,0,0,1.2-3.11C67.4,143.34,66,142,65,140.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M54.32,138.43a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.25l0,0,0,0c-.11,0-.28.47-.33.55A7.52,7.52,0,0,1,51.58,138c-1.46,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.23,2.23,0,0,0,2-.81,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.54,3.7,3.7,0,0,0,1.2-3.11C56.72,141.56,55.3,140.24,54.32,138.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M43.63,136.65a7.48,7.48,0,0,1-.76-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.65,2.65,0,0,0,2,2.64,2.15,2.15,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C46,139.79,44.62,138.47,43.63,136.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M33,134.88a7.29,7.29,0,0,1-.77-2c0-.19-.08-.38-.11-.58s0-.24-.08-.24,0,0,0,0a0,0,0,0,0,0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.71,3.71,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.72,3.72,0,0,0,1.2-3.1C35.36,138,33.93,136.7,33,134.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M35.4,132.4a7.48,7.48,0,0,1,.76,2,5.22,5.22,0,0,1,.11.57c0,.16,0,.24.09.25l0,0s0,0,0,0,.27-.48.32-.56a7.57,7.57,0,0,1,1.4-1.86c1.46-1.47,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.81,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C33,129.26,34.42,130.58,35.4,132.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M46.08,134.17a8,8,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.17,0,.24.09.25s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.75,3.75,0,0,0-1.2,3.11C43.68,131,45.1,132.35,46.08,134.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M56.76,135.94a7.57,7.57,0,0,1,.77,2c0,.18.07.37.1.57s0,.23.08.24,0,0,0,0l0,0c.1,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.31,2.07,2.07,0,0,0-1.45-1,2.18,2.18,0,0,0-2,.81,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C54.36,132.8,55.78,134.13,56.76,135.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M67.44,137.72a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16,0,.24.08.25l0,0s0,0,0,0,.27-.48.32-.56a7.57,7.57,0,0,1,1.4-1.86c1.46-1.47,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.81,3.85,3.85,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.16,2.16,0,0,0-1.67.54,3.69,3.69,0,0,0-1.19,3.11C65,134.58,66.46,135.9,67.44,137.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M78.12,139.49a7.28,7.28,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16.05.23.09.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.71,3.71,0,0,0-1.19,3.11C75.72,136.35,77.14,137.67,78.12,139.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M88.8,141.26a7.93,7.93,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57q0,.24.09.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.12,2.12,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.72,3.72,0,0,0-1.2,3.1C86.4,138.12,87.82,139.45,88.8,141.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M99.48,143a7.5,7.5,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16.05.24.09.25l0,0,0,0c.11,0,.27-.48.32-.56a7.57,7.57,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.71,3.71,0,0,0-1.21,3.11C97.08,139.9,98.5,141.22,99.48,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M110.16,144.81a7.57,7.57,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16,0,.23.09.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.73,3.73,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.66,3.66,0,0,0-1.2,3.1C107.76,141.67,109.18,143,110.16,144.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M120.84,146.58a7.57,7.57,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16.05.24.09.25l0,0,0,0c.1,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.18,2.18,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.69,3.69,0,0,0-1.19,3.11C118.44,143.44,119.86,144.77,120.84,146.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M115.79,171.05a7.41,7.41,0,0,1-.76-2,5.4,5.4,0,0,1-.11-.58c0-.16,0-.24-.08-.24a0,0,0,0,0,0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.76,3.76,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.45,1,2.22,2.22,0,0,0,2-.82,3.65,3.65,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C118.19,174.19,116.77,172.86,115.79,171.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M105.11,169.28a7.69,7.69,0,0,1-.76-2,5.22,5.22,0,0,1-.11-.57c0-.16,0-.24-.08-.25l0,0s0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.19,2.19,0,0,0,2-.82,3.49,3.49,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C107.51,172.41,106.09,171.09,105.11,169.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M94.43,167.5a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.49,3.49,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C96.83,170.64,95.41,169.31,94.43,167.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M83.75,165.73a8.08,8.08,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57c0-.16,0-.24-.08-.24s0,0,0,0l0,0c-.1,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.31-3.85,3.88a3.76,3.76,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.45,1,2.22,2.22,0,0,0,1.95-.82,3.85,3.85,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.67,3.67,0,0,0,1.2-3.11C86.15,168.86,84.73,167.54,83.75,165.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M73.07,164a7.84,7.84,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16,0-.24-.08-.25a.05.05,0,0,0,0,0s0,0,0,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.74,3.74,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.63,2.63,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.69,3.69,0,0,0,1.19-3.11C75.47,167.09,74.05,165.77,73.07,164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M62.39,162.18a7.63,7.63,0,0,1-.77-2c0-.19-.07-.38-.1-.57s-.05-.24-.08-.25,0,0,0,0l0,0c-.1,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53A3.73,3.73,0,0,0,65,167C64.79,165.32,63.37,164,62.39,162.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M51.71,160.41a7.7,7.7,0,0,1-.77-2c0-.18-.07-.37-.1-.57s-.05-.24-.09-.24,0,0,0,0,0,0,0,0-.27.47-.32.55A7.82,7.82,0,0,1,49,160c-1.46,1.46-3.2,2.31-3.85,3.88a3.73,3.73,0,0,0,.26,3.32,2.12,2.12,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.65,3.65,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C54.11,163.54,52.69,162.22,51.71,160.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M41,158.64a7.84,7.84,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.46-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53,3.67,3.67,0,0,0,1.2-3.11C43.43,161.77,42,160.45,41,158.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M30.35,156.86a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.17-.05-.24-.09-.25s0,0,0,0l0,0c-.11,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.79,3.79,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53,3.69,3.69,0,0,0,1.2-3.11C32.75,160,31.33,158.67,30.35,156.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M32.79,154.37a7.84,7.84,0,0,1,.77,2c0,.19.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.46.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.64,2.64,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C30.39,151.24,31.81,152.56,32.79,154.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M43.47,156.15a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0,0,0,0,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.61,2.61,0,0,0-1.95-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C41.07,153,42.49,154.34,43.47,156.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M54.15,157.92a7.7,7.7,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.24h0l0,0c.11,0,.28-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.46,3.2-2.32,3.85-3.88a3.75,3.75,0,0,0-.25-3.33,2.15,2.15,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-1.95-2.64,2.07,2.07,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C51.75,154.79,53.17,156.11,54.15,157.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M64.83,159.69a7.84,7.84,0,0,1,.77,2c0,.19.08.37.11.57s.05.24.08.25l0,0s0,0,0,0,.28-.46.32-.55a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.62,2.62,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.7,3.7,0,0,0-1.2,3.11C62.43,156.56,63.85,157.88,64.83,159.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M75.51,161.47a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25,0,0,0,0,0,0,0,0,.27-.47.31-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.25-3.32,2.1,2.1,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.47,3.47,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.53,3.71,3.71,0,0,0-1.2,3.11C73.11,158.33,74.54,159.66,75.51,161.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M86.19,163.24a7.36,7.36,0,0,1,.77,2c0,.18.08.37.11.57s.05.24.08.24,0,0,0,0a0,0,0,0,0,0,0c.11,0,.28-.47.33-.55a7.52,7.52,0,0,1,1.39-1.87c1.46-1.46,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.25-3.32,2.13,2.13,0,0,0-1.45-1,2.23,2.23,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C83.79,160.11,85.21,161.43,86.19,163.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M96.87,165a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.47.32-.56a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.25-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.6,2.6,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53,3.73,3.73,0,0,0-1.2,3.11C94.47,161.88,95.9,163.2,96.87,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M107.55,166.79a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s0,.25.08.25l0,0s0,0,0,0,.28-.47.32-.56a7.74,7.74,0,0,1,1.41-1.86c1.45-1.46,3.19-2.32,3.84-3.88a3.72,3.72,0,0,0-.25-3.33,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.58,3.58,0,0,0-.67,1.14,2.63,2.63,0,0,0-2-2.63,2.1,2.1,0,0,0-1.67.53A3.74,3.74,0,0,0,105,162C105.15,163.65,106.58,165,107.55,166.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M118.23,168.56a7.36,7.36,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.24,0,0,0,0l0,0c.1,0,.27-.47.31-.55A8,8,0,0,1,121,169c1.46-1.45,3.21-2.31,3.85-3.88a3.72,3.72,0,0,0-.25-3.33,2.13,2.13,0,0,0-1.45-1,2.24,2.24,0,0,0-2,.82,3.63,3.63,0,0,0-.67,1.15,2.64,2.64,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C115.83,165.43,117.26,166.75,118.23,168.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M125.54,106.08a7.36,7.36,0,0,1-.77-2c0-.18-.08-.37-.11-.57s0-.24-.08-.24,0,0,0,0l0,0c-.11,0-.28.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.46,1.46-3.2,2.31-3.85,3.88a3.75,3.75,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.06,2.06,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C127.94,109.22,126.52,107.89,125.54,106.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M114.86,104.3a7.29,7.29,0,0,1-.77-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.46-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.73,3.73,0,0,0,.25,3.32,2.09,2.09,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.6,2.6,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.71,3.71,0,0,0,1.2-3.11C117.26,107.44,115.83,106.12,114.86,104.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M104.18,102.53a7.42,7.42,0,0,1-.77-2c0-.19-.08-.38-.11-.57s0-.25-.08-.25,0,0,0,0,0,0,0,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.47,3.47,0,0,0,.67-1.14,2.63,2.63,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.72,3.72,0,0,0,1.2-3.11C106.58,105.67,105.15,104.34,104.18,102.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M93.49,100.76a7.69,7.69,0,0,1-.76-2c0-.19-.08-.37-.11-.57s-.05-.24-.08-.25l0,0s0,0,0,0-.27.47-.31.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.21,2.31-3.85,3.88a3.7,3.7,0,0,0,.25,3.32,2.11,2.11,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.63,3.63,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C95.9,103.89,94.47,102.57,93.49,100.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M82.81,99a7.62,7.62,0,0,1-.76-2c0-.19-.08-.38-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.46-.33.55a7.47,7.47,0,0,1-1.39,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14,2.62,2.62,0,0,0,2,2.63,2.09,2.09,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C85.22,102.12,83.8,100.8,82.81,99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M72.13,97.21a7.62,7.62,0,0,1-.76-2c0-.19-.08-.38-.11-.57s-.05-.25-.08-.25,0,0,0,0a0,0,0,0,0,0,0c-.1,0-.27.47-.31.55a7.6,7.6,0,0,1-1.41,1.87c-1.45,1.46-3.19,2.32-3.84,3.88A3.75,3.75,0,0,0,65.8,104a2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.76,3.76,0,0,0,1.2-3.12C74.54,100.35,73.11,99,72.13,97.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M61.46,95.44a7.36,7.36,0,0,1-.77-2c0-.19-.08-.37-.11-.57s0-.24-.08-.25l0,0s0,0,0,0-.28.47-.33.55A7.5,7.5,0,0,1,58.71,95c-1.45,1.45-3.19,2.31-3.84,3.88a3.7,3.7,0,0,0,.25,3.32,2.07,2.07,0,0,0,1.45,1,2.19,2.19,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14,2.64,2.64,0,0,0,2,2.64,2.07,2.07,0,0,0,1.67-.54,3.73,3.73,0,0,0,1.2-3.11C63.86,98.57,62.43,97.25,61.46,95.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M50.77,93.66a7.62,7.62,0,0,1-.76-2,5.72,5.72,0,0,1-.11-.57c0-.16,0-.24-.08-.25s0,0,0,0,0,0,0,0-.27.47-.32.56A7.47,7.47,0,0,1,48,93.26c-1.46,1.46-3.21,2.32-3.85,3.89a3.7,3.7,0,0,0,.25,3.32,2.1,2.1,0,0,0,1.45,1,2.21,2.21,0,0,0,2-.82,3.65,3.65,0,0,0,.67-1.14,2.62,2.62,0,0,0,2,2.63,2.1,2.1,0,0,0,1.67-.53,3.74,3.74,0,0,0,1.2-3.11C53.18,96.8,51.75,95.48,50.77,93.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M40.09,91.89a7.62,7.62,0,0,1-.76-2c0-.19-.08-.38-.11-.57s0-.25-.08-.25,0,0,0,0a0,0,0,0,0,0,0c-.1,0-.27.47-.32.55a7.82,7.82,0,0,1-1.4,1.87c-1.45,1.46-3.2,2.32-3.84,3.88a3.72,3.72,0,0,0,.25,3.33,2.13,2.13,0,0,0,1.45,1,2.24,2.24,0,0,0,2-.82,3.82,3.82,0,0,0,.67-1.15,2.64,2.64,0,0,0,2,2.64,2.1,2.1,0,0,0,1.67-.53,3.76,3.76,0,0,0,1.2-3.12C42.5,95,41.07,93.7,40.09,91.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M42.54,89.4a7.69,7.69,0,0,1,.76,2c0,.18.08.37.11.57s.05.24.08.24,0,0,0,0,0,0,0,0,.27-.47.32-.55a7.32,7.32,0,0,1,1.4-1.87c1.45-1.45,3.2-2.31,3.84-3.88a3.7,3.7,0,0,0-.25-3.32,2.11,2.11,0,0,0-1.45-1,2.25,2.25,0,0,0-2,.82,3.82,3.82,0,0,0-.67,1.15,2.63,2.63,0,0,0-2-2.64,2.07,2.07,0,0,0-1.67.54A3.73,3.73,0,0,0,40,84.58C40.13,86.27,41.56,87.59,42.54,89.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M53.21,91.18a7.29,7.29,0,0,1,.77,2,5.72,5.72,0,0,1,.11.57c0,.16,0,.24.08.25l0,0s0,0,0,0,.27-.47.32-.55A7.51,7.51,0,0,1,56,91.58c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.65,3.65,0,0,0-.67,1.14,2.61,2.61,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C50.82,88,52.24,89.36,53.21,91.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M63.9,93a7.62,7.62,0,0,1,.76,2,5.4,5.4,0,0,1,.11.58c0,.16,0,.24.08.24s0,0,0,0a0,0,0,0,0,0,0c.1,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.45-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.1,2.1,0,0,0-1.45-1,2.21,2.21,0,0,0-2,.82,3.77,3.77,0,0,0-.67,1.14,2.62,2.62,0,0,0-2-2.63,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C61.49,89.81,62.92,91.14,63.9,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M74.58,94.72a7.69,7.69,0,0,1,.76,2,5.22,5.22,0,0,1,.11.57c0,.16,0,.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.45-1,2.21,2.21,0,0,0-1.95.82,3.65,3.65,0,0,0-.68,1.15,2.64,2.64,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54A3.73,3.73,0,0,0,72,89.9C72.18,91.59,73.6,92.91,74.58,94.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M85.26,96.5a8,8,0,0,1,.77,2,5.67,5.67,0,0,1,.1.57c0,.16.05.24.08.25s0,0,0,0,0,0,0,0,.27-.47.32-.56A7.51,7.51,0,0,1,88,96.9c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C82.86,93.36,84.28,94.69,85.26,96.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M95.94,98.27a7.93,7.93,0,0,1,.77,2,4.82,4.82,0,0,1,.1.57c0,.16,0,.24.08.24a0,0,0,0,0,0,0s0,0,0,0,.27-.47.32-.56a7.7,7.7,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.76,3.76,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.45-1,2.19,2.19,0,0,0-1.95.82,3.54,3.54,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C93.54,95.13,95,96.46,95.94,98.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M106.62,100a7.48,7.48,0,0,1,.76,2,5.22,5.22,0,0,1,.11.57c0,.16.05.24.08.24s0,0,0,0,0,0,0,0,.27-.47.32-.55a8,8,0,0,1,1.4-1.87c1.46-1.45,3.2-2.31,3.85-3.88a3.73,3.73,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.17,2.17,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.62,2.62,0,0,0-2-2.64,2.09,2.09,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C104.22,96.91,105.64,98.23,106.62,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M117.3,101.82a7.62,7.62,0,0,1,.76,2,5.72,5.72,0,0,1,.11.57c0,.16,0,.24.09.25a0,0,0,0,0,0,0s0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.74,3.74,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.45-1,2.19,2.19,0,0,0-2,.82,3.49,3.49,0,0,0-.68,1.14,2.61,2.61,0,0,0-2-2.63,2.11,2.11,0,0,0-1.67.53,3.74,3.74,0,0,0-1.2,3.11C114.9,98.68,116.32,100,117.3,101.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M128,103.59a8.15,8.15,0,0,1,.77,2,5.4,5.4,0,0,1,.1.58q0,.24.09.24s0,0,0,0,0,0,0,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.88a3.76,3.76,0,0,0-.26-3.33,2.13,2.13,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.82,3.65,3.65,0,0,0-.68,1.15,2.63,2.63,0,0,0-2-2.64,2.05,2.05,0,0,0-1.66.54,3.71,3.71,0,0,0-1.21,3.11C125.58,100.45,127,101.78,128,103.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M122.93,128.06a7.93,7.93,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57q0-.24-.09-.24s0,0,0,0l0,0c-.11,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.45,1,2.22,2.22,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.63,2.63,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.68,3.68,0,0,0,1.19-3.1C125.33,131.2,123.91,129.88,122.93,128.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M112.25,126.29a7.7,7.7,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16,0-.24-.08-.25l0,0,0,0c-.11,0-.27.47-.32.55a8,8,0,0,1-1.4,1.87c-1.46,1.45-3.2,2.31-3.85,3.88a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.7,3.7,0,0,0,1.2-3.11C114.65,129.42,113.23,128.1,112.25,126.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M101.57,124.51a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.17,0-.24-.08-.25a.05.05,0,0,0,0,0s0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.11,2.11,0,0,0,1.67-.53,3.72,3.72,0,0,0,1.19-3.11C104,127.65,102.55,126.33,101.57,124.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M90.89,122.74a7.7,7.7,0,0,1-.77-2c0-.18-.07-.37-.1-.57s0-.24-.09-.24,0,0,0,0l0,0c-.11,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.74,3.74,0,0,0,.26,3.32,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.09,2.09,0,0,0,1.67-.54,3.71,3.71,0,0,0,1.19-3.1C93.29,125.88,91.87,124.55,90.89,122.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M80.21,121a7.5,7.5,0,0,1-.77-2,5.21,5.21,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.47-.32.55a7.76,7.76,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.7,3.7,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81A3.85,3.85,0,0,0,78,126.8a2.63,2.63,0,0,0,2,2.64,2.12,2.12,0,0,0,1.66-.54,3.67,3.67,0,0,0,1.2-3.11C82.61,124.1,81.19,122.78,80.21,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M69.53,119.19a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.17,0-.24-.09-.25s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89A3.71,3.71,0,0,0,63.2,126a2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.62,2.62,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53A3.7,3.7,0,0,0,72.1,124C71.93,122.33,70.51,121,69.53,119.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M58.85,117.42a7.7,7.7,0,0,1-.77-2,4.82,4.82,0,0,1-.1-.57q0-.24-.09-.24s0,0,0,0l0,0c-.11,0-.28.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.88a3.72,3.72,0,0,0,.26,3.33,2.13,2.13,0,0,0,1.44,1,2.23,2.23,0,0,0,2-.82,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.05,2.05,0,0,0,1.66-.54,3.69,3.69,0,0,0,1.2-3.1C61.25,120.56,59.83,119.23,58.85,117.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M48.17,115.64a7.5,7.5,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.16,0-.24-.09-.25l0,0s0,0,0,0-.27.48-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.07,2.07,0,0,0,1.44,1,2.22,2.22,0,0,0,2-.81,3.85,3.85,0,0,0,.68-1.15,2.62,2.62,0,0,0,2,2.64,2.16,2.16,0,0,0,1.67-.54,3.72,3.72,0,0,0,1.19-3.11C50.57,118.78,49.15,117.46,48.17,115.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M37.49,113.87a7.63,7.63,0,0,1-.77-2,5.67,5.67,0,0,1-.1-.57c0-.17-.06-.24-.09-.25s0,0,0,0,0,0,0,0-.27.47-.32.56a8,8,0,0,1-1.4,1.86c-1.46,1.46-3.2,2.32-3.85,3.89a3.71,3.71,0,0,0,.26,3.32,2.1,2.1,0,0,0,1.44,1,2.2,2.2,0,0,0,2-.82,3.67,3.67,0,0,0,.68-1.14,2.61,2.61,0,0,0,2,2.63,2.08,2.08,0,0,0,1.66-.53,3.72,3.72,0,0,0,1.2-3.11C39.89,117,38.47,115.69,37.49,113.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M39.93,111.39a7.5,7.5,0,0,1,.77,2c0,.18.08.38.11.57s0,.24.08.25l0,0s0,0,0,0,.27-.48.32-.56a7.76,7.76,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.07,2.07,0,0,0-1.44-1,2.22,2.22,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.12,2.12,0,0,0-1.66.54,3.7,3.7,0,0,0-1.2,3.11C37.53,108.25,39,109.57,39.93,111.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M50.61,113.16a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.58s0,.23.08.24h0l0,0c.11,0,.27-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.11,2.11,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.61,3.61,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.08,2.08,0,0,0-1.66.53,3.71,3.71,0,0,0-1.2,3.11C48.21,110,49.63,111.34,50.61,113.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M61.29,114.93a7.57,7.57,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.24,0,0,0,0l0,0c.11,0,.28-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.46,3.2-2.32,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.19,2.19,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-1.95-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C58.89,111.8,60.31,113.12,61.29,114.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M72,116.71a7.63,7.63,0,0,1,.77,2c0,.19.08.38.11.57s.05.24.08.25l0,0,0,0c.11,0,.28-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.7,3.7,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.63,2.63,0,0,0-2-2.64,2.13,2.13,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C69.57,113.57,71,114.89,72,116.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M82.65,118.48a7.57,7.57,0,0,1,.77,2c0,.18.08.37.11.57s0,.23.08.24,0,0,0,0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.71,3.71,0,0,0-.26-3.32,2.13,2.13,0,0,0-1.44-1,2.23,2.23,0,0,0-2,.82,3.61,3.61,0,0,0-.68,1.15A2.62,2.62,0,0,0,83,110a2.06,2.06,0,0,0-1.67.54,3.69,3.69,0,0,0-1.2,3.1C80.25,115.34,81.67,116.66,82.65,118.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M93.33,120.25a7.57,7.57,0,0,1,.77,2c0,.18.08.37.11.57s.05.24.08.25l0,0,0,0c.11,0,.27-.47.32-.55a7.82,7.82,0,0,1,1.4-1.87c1.46-1.46,3.2-2.32,3.85-3.88a3.7,3.7,0,0,0-.26-3.32,2.05,2.05,0,0,0-1.44-1,2.19,2.19,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C90.93,117.12,92.36,118.44,93.33,120.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M104,122a7.29,7.29,0,0,1,.77,2c0,.19.08.38.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.48.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89a3.73,3.73,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.2,2.2,0,0,0-2,.82,3.67,3.67,0,0,0-.68,1.14,2.64,2.64,0,0,0-2-2.64,2.13,2.13,0,0,0-1.67.54,3.7,3.7,0,0,0-1.2,3.11C101.61,118.89,103,120.21,104,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M114.69,123.8a7.24,7.24,0,0,1,.77,2c0,.18.08.37.11.57s.05.23.08.24h0l0,0c.11,0,.28-.47.32-.56a8,8,0,0,1,1.4-1.86c1.46-1.46,3.2-2.32,3.85-3.89A3.74,3.74,0,0,0,121,117a2.15,2.15,0,0,0-1.45-1,2.23,2.23,0,0,0-2,.82A3.52,3.52,0,0,0,117,118a2.64,2.64,0,0,0-2-2.64,2.06,2.06,0,0,0-1.67.54,3.69,3.69,0,0,0-1.2,3.1C112.29,120.66,113.71,122,114.69,123.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M125.37,125.57a7.7,7.7,0,0,1,.77,2c0,.18.08.37.11.57s0,.24.08.25l0,0s0,0,0,0,.28-.47.32-.55a7.57,7.57,0,0,1,1.4-1.86c1.46-1.47,3.2-2.33,3.85-3.89a3.73,3.73,0,0,0-.25-3.32,2.09,2.09,0,0,0-1.45-1,2.22,2.22,0,0,0-2,.81,3.85,3.85,0,0,0-.68,1.15,2.62,2.62,0,0,0-2-2.64,2.1,2.1,0,0,0-1.67.54,3.73,3.73,0,0,0-1.2,3.11C123,122.44,124.39,123.76,125.37,125.57Z"
  })))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M77.53,180a4.67,4.67,0,1,1,4.67,4.67A4.67,4.67,0,0,1,77.53,180Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.7,188.89s.33,1.5-2.09,1.75S86.2,190.56,86.7,188.89Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M90.48,173.09l-.6,1.59-2.35-.08A4.06,4.06,0,0,1,90.48,173.09Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M90.68,176.28a3.55,3.55,0,0,0-.54.24s-2.07-.8-2.61-1.92l2.35.08Z"
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    width: 58,
    height: 61,
    transform: "translate(32.23 149.5)",
    xlinkHref: "data:image/png;base64,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"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125.69,107.76l-14.62,1.68,1,4a15.29,15.29,0,0,1-.43,5.79c-.23.72,1.7,1.58,2.54-1.7l1-3,.85,8.32s.26,4.77,1.41,3.82c.73-.59,1.09-2.94,1-3.64s.36-7.3.36-7.3l1,6.48s.51,5,1.12,4.85c2.29-.52,1.73-3.59,1.54-4.39s-.58-7.64-.58-7.64l2.16,7.59s.54,3.2,1.18,2.82c1.56-.93,1.12-3.11,1-3.53-.21-.77-1.45-6.79-1.45-6.79l1.11,1.44s2.42,5.09,2.77,4.79c1.75-1.5-2.21-11-2.21-11A22.53,22.53,0,0,0,125.69,107.76Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M55.68,155.5a2.34,2.34,0,0,1-.37-.54c0-.05-.05-.11-.08-.16s0-.07,0-.07h0s-.05.16-.05.19a2.41,2.41,0,0,1-.29.66c-.32.53-.78.91-.86,1.43a1.12,1.12,0,0,0,.31,1,.65.65,0,0,0,.5.19.68.68,0,0,0,.53-.39,1.13,1.13,0,0,0,.12-.38.79.79,0,0,0,.77.64.67.67,0,0,0,.46-.28,1.16,1.16,0,0,0,.13-1C56.62,156.26,56.1,156,55.68,155.5Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M56,158.87a2.73,2.73,0,0,1-.38-.54l-.07-.16s0-.07,0-.07a0,0,0,0,0,0,0h0s0,.16,0,.19a2.76,2.76,0,0,1-.29.66c-.33.53-.78.91-.87,1.43a1.16,1.16,0,0,0,.32,1,.65.65,0,0,0,.5.19.66.66,0,0,0,.52-.39.81.81,0,0,0,.12-.38.81.81,0,0,0,.78.64.63.63,0,0,0,.45-.28,1.13,1.13,0,0,0,.14-1C57,159.63,56.44,159.34,56,158.87Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M56.35,162.24a2.34,2.34,0,0,1-.37-.54l-.07-.16s0-.07,0-.07h0s-.05.16-.06.19a2.51,2.51,0,0,1-.28.65c-.33.54-.79.92-.87,1.44a1.16,1.16,0,0,0,.32,1,.62.62,0,0,0,1-.2,1.13,1.13,0,0,0,.12-.38.8.8,0,0,0,.77.64.67.67,0,0,0,.46-.28,1.13,1.13,0,0,0,.13-1C57.29,163,56.77,162.71,56.35,162.24Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M56.69,165.61a2.34,2.34,0,0,1-.37-.54s0-.11-.08-.16,0-.07,0-.07h0s0,.16,0,.19a2.51,2.51,0,0,1-.28.65c-.33.54-.79.92-.87,1.44a1.15,1.15,0,0,0,.31,1,.71.71,0,0,0,.51.19.68.68,0,0,0,.52-.39,1.12,1.12,0,0,0,.12-.39.8.8,0,0,0,.77.65.67.67,0,0,0,.46-.28,1.13,1.13,0,0,0,.13-1C57.63,166.37,57.11,166.08,56.69,165.61Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M57,169a2.73,2.73,0,0,1-.38-.54l-.07-.16c0-.05,0-.07,0-.07h0s-.05.16-.06.19a2.21,2.21,0,0,1-.28.65c-.33.54-.78.92-.87,1.44a1.16,1.16,0,0,0,.32,1,.68.68,0,0,0,.5.19.66.66,0,0,0,.52-.39.94.94,0,0,0,.12-.39.82.82,0,0,0,.78.65.63.63,0,0,0,.45-.28,1.14,1.14,0,0,0,.14-1C58,169.74,57.45,169.45,57,169Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M57.36,172.35a2.34,2.34,0,0,1-.37-.54l-.07-.16c0-.05,0-.07,0-.07h0s0,.16-.06.19a2.51,2.51,0,0,1-.28.65c-.33.54-.79.92-.87,1.43a1.17,1.17,0,0,0,.32,1,.68.68,0,0,0,.5.19.66.66,0,0,0,.52-.39,1.12,1.12,0,0,0,.12-.39.81.81,0,0,0,.77.65.65.65,0,0,0,.46-.28,1.13,1.13,0,0,0,.13-1C58.3,173.11,57.79,172.82,57.36,172.35Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M57.7,175.72a2.34,2.34,0,0,1-.37-.54,1.11,1.11,0,0,1-.07-.16c0-.05,0-.07,0-.07h0s0,.16,0,.19a2.51,2.51,0,0,1-.28.65c-.33.54-.79.92-.87,1.43a1.13,1.13,0,0,0,.31,1,.67.67,0,0,0,.5.2.68.68,0,0,0,.53-.39,1.12,1.12,0,0,0,.12-.39.8.8,0,0,0,.77.65.67.67,0,0,0,.46-.28,1.13,1.13,0,0,0,.13-1C58.64,176.48,58.12,176.18,57.7,175.72Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M58.09,179a2.2,2.2,0,0,1-.47-.45l-.1-.14s-.05-.06-.06-.06h0s0,.16,0,.19a2.09,2.09,0,0,1-.15.7c-.21.59-.58,1.06-.55,1.58a1.12,1.12,0,0,0,.5.88.63.63,0,0,0,.53.09.73.73,0,0,0,.44-.48,1.12,1.12,0,0,0,0-.41.83.83,0,0,0,.89.48.65.65,0,0,0,.39-.37,1.15,1.15,0,0,0-.07-1C59.17,179.54,58.6,179.36,58.09,179Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M59.11,182.21a2.24,2.24,0,0,1-.48-.45l-.1-.14s0-.06-.05-.06h0s0,.16,0,.19a2.35,2.35,0,0,1-.14.7c-.22.6-.59,1.06-.56,1.58a1.17,1.17,0,0,0,.5.89.63.63,0,0,0,1-.4,1.36,1.36,0,0,0,0-.41.81.81,0,0,0,.88.48.69.69,0,0,0,.4-.37,1.15,1.15,0,0,0-.08-1C60.18,182.77,59.62,182.59,59.11,182.21Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M60.12,185.44a2,2,0,0,1-.47-.45.71.71,0,0,1-.1-.14l-.06-.06h0s0,.16,0,.19a2.37,2.37,0,0,1-.15.7c-.21.6-.58,1.06-.56,1.58a1.15,1.15,0,0,0,.51.89.62.62,0,0,0,.53.08.68.68,0,0,0,.43-.48,1.08,1.08,0,0,0,0-.41.8.8,0,0,0,.89.48.67.67,0,0,0,.39-.37,1.15,1.15,0,0,0-.08-1C61.2,186,60.63,185.82,60.12,185.44Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M61.13,188.68a2.54,2.54,0,0,1-.47-.46l-.1-.14s-.05-.06-.06-.06h0s0,.16,0,.19a2,2,0,0,1-.15.7c-.21.6-.58,1.06-.55,1.58a1.14,1.14,0,0,0,.5.89.63.63,0,0,0,.53.08.69.69,0,0,0,.44-.48,1.09,1.09,0,0,0,0-.41.81.81,0,0,0,.89.48.65.65,0,0,0,.39-.37,1.1,1.1,0,0,0-.07-1C62.21,189.23,61.64,189.05,61.13,188.68Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M62.15,191.91a2.49,2.49,0,0,1-.47-.45l-.11-.15s0-.06,0-.06h0s0,.17,0,.2a2.29,2.29,0,0,1-.14.69,4.71,4.71,0,0,0-.56,1.58,1.13,1.13,0,0,0,.51.89.62.62,0,0,0,.53.08.66.66,0,0,0,.43-.48,1,1,0,0,0,0-.4.8.8,0,0,0,.88.47.6.6,0,0,0,.39-.37,1.1,1.1,0,0,0-.07-1C63.22,192.46,62.66,192.28,62.15,191.91Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M63.7,194.76a2.18,2.18,0,0,1-.58-.31l-.14-.11s-.06-.05-.07,0h0s0,.16,0,.19a2.15,2.15,0,0,1,0,.71,4.7,4.7,0,0,0-.12,1.67,1.12,1.12,0,0,0,.73.72.62.62,0,0,0,.53-.06.66.66,0,0,0,.29-.58,1.16,1.16,0,0,0-.07-.4.8.8,0,0,0,1,.22.65.65,0,0,0,.28-.46,1.15,1.15,0,0,0-.34-1A4.75,4.75,0,0,0,63.7,194.76Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M65.54,197.6a2,2,0,0,1-.58-.31l-.14-.11-.07,0h0s0,.17,0,.2a2.41,2.41,0,0,1,0,.71,4.69,4.69,0,0,0-.12,1.67,1.15,1.15,0,0,0,.72.72.67.67,0,0,0,.54-.06.69.69,0,0,0,.29-.58,1.12,1.12,0,0,0-.07-.4.8.8,0,0,0,1,.22.68.68,0,0,0,.28-.46,1.13,1.13,0,0,0-.35-1C66.72,197.85,66.12,197.83,65.54,197.6Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M67.21,200.41a2.56,2.56,0,0,1-.64-.12l-.16-.06s-.08,0-.08,0h0s.07.15.09.18a2.55,2.55,0,0,1,.27.66,4.38,4.38,0,0,0,.4,1.62,1.12,1.12,0,0,0,.91.46.6.6,0,0,0,.49-.22.65.65,0,0,0,.09-.64,1,1,0,0,0-.19-.36.8.8,0,0,0,1-.09.64.64,0,0,0,.13-.52,1.15,1.15,0,0,0-.63-.81A4.7,4.7,0,0,0,67.21,200.41Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M69.84,202.54a2.46,2.46,0,0,1-.64-.11l-.17-.07H69s0,0,0,0h0s.08.15.1.18a2.22,2.22,0,0,1,.26.66,4.63,4.63,0,0,0,.41,1.62,1.12,1.12,0,0,0,.91.46.61.61,0,0,0,.48-.22.66.66,0,0,0,.1-.64,1.14,1.14,0,0,0-.19-.36.8.8,0,0,0,1-.09.6.6,0,0,0,.12-.52,1.1,1.1,0,0,0-.62-.81A4.94,4.94,0,0,0,69.84,202.54Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M72.51,204.37a2.24,2.24,0,0,1-.65.07l-.17,0s-.08,0-.08,0h0s.12.12.14.14a2.42,2.42,0,0,1,.44.56c.31.55.42,1.13.84,1.45a1.15,1.15,0,0,0,1,.19.65.65,0,0,0,.41-.35.7.7,0,0,0-.09-.65,1.52,1.52,0,0,0-.28-.29.78.78,0,0,0,.93-.36.68.68,0,0,0,0-.54,1.13,1.13,0,0,0-.83-.6C73.63,203.91,73.13,204.23,72.51,204.37Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M71.54,199s4.52,7.29,12.19,8.71c5.63,1,5.71,3.54,5.71,3.54s2-6.92,1.92-10.17C91.36,201.12,82.36,205.33,71.54,199Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M88.22,203.85a3,3,0,0,1-.45-.72,1.8,1.8,0,0,1-.08-.21c0-.07,0-.09-.06-.09h0s-.07.2-.08.24a3.18,3.18,0,0,1-.4.83c-.46.67-1.07,1.13-1.2,1.79a1.46,1.46,0,0,0,.35,1.27.84.84,0,0,0,.63.28.86.86,0,0,0,.7-.46,1.43,1.43,0,0,0,.18-.5,1,1,0,0,0,1,.88.85.85,0,0,0,.61-.33,1.5,1.5,0,0,0,.23-1.3C89.39,204.89,88.74,204.48,88.22,203.85Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M84.12,204a2.55,2.55,0,0,1-.31-.69,1.46,1.46,0,0,1,0-.2c0-.06,0-.08,0-.09a0,0,0,0,1,0,0,0,0,0,0,0,0,0s-.08.17-.1.21a2.81,2.81,0,0,1-.46.68c-.48.54-1.08.87-1.28,1.44a1.33,1.33,0,0,0,.16,1.16.73.73,0,0,0,.53.33.79.79,0,0,0,.67-.33,1.23,1.23,0,0,0,.22-.41.93.93,0,0,0,.74.89.72.72,0,0,0,.58-.22,1.31,1.31,0,0,0,.36-1.12C85,205,84.5,204.58,84.12,204Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M80.54,203.49a1.67,1.67,0,0,1-.14-.51s0-.1,0-.15,0-.06,0-.06h0s-.08.11-.1.13a1.73,1.73,0,0,1-.39.42c-.4.32-.85.49-1.05.86a.93.93,0,0,0,0,.83.56.56,0,0,0,.33.28.55.55,0,0,0,.51-.15,1.18,1.18,0,0,0,.2-.27.66.66,0,0,0,.41.71.55.55,0,0,0,.43-.09.93.93,0,0,0,.37-.74C81.05,204.33,80.73,204,80.54,203.49Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M77.44,202.62a1.27,1.27,0,0,1,0-.34v-.1s0,0,0,0h0s-.06.06-.07.07a1,1,0,0,1-.29.24c-.28.17-.59.24-.75.46a.62.62,0,0,0-.08.53.33.33,0,0,0,.52.16.46.46,0,0,0,.15-.16.42.42,0,0,0,.21.49.31.31,0,0,0,.28,0,.62.62,0,0,0,.31-.44A2.74,2.74,0,0,0,77.44,202.62Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M69.76,145.49a7.43,7.43,0,0,1,2.53.45c6.41,2.33,5.63,9,5.63,9.12l-.16.12c0-.07.37-6.51-5.65-8.7s-12,5.26-12,5.34l-.43-.36C59.88,151.18,64.39,145.49,69.76,145.49Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M73.46,140.67a4.64,4.64,0,0,1-.35-1.23l0-.34a.24.24,0,0,0,0-.15h0s0,0,0,0-.19.27-.22.31a4.88,4.88,0,0,1-.93,1c-1,.79-2,1.2-2.5,2.1a2.21,2.21,0,0,0,0,2,1.23,1.23,0,0,0,.8.67,1.33,1.33,0,0,0,1.21-.39,2,2,0,0,0,.46-.64,1.57,1.57,0,0,0,1,1.67,1.23,1.23,0,0,0,1-.23,2.22,2.22,0,0,0,.88-1.78C74.72,142.66,74,141.8,73.46,140.67Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M34.71,151.46l22.9,3.93a101,101,0,0,0,19.25-42l-34.75,4S45.3,136.78,34.71,151.46Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M51.86,154.64s14.5-19.25,16-40.25l-6.5.75s-3.79,26.72-16.52,38.24Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.61,186.87s-1-12,5-12.75C73.61,174.12,64.36,171.12,68.61,186.87Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M123.48,121.4s3.08,15.52-4.68,28.83l-.66-.51s7.47-9.16,4.5-29.09Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M118.79,152.11s0,3.81.44,4.4c0,0-.62,2.11-2,2.28,0,0-2-2-1.34-3.21A23.36,23.36,0,0,1,118.79,152.11Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M118.88,152.45s1.15,5.58-3.47,6l-3.2-1.27a3.29,3.29,0,0,1,.8-4.64C115.68,150.42,119.14,149.92,118.88,152.45Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M118.05,151.48s-6.77-.7-7.74,1.16,2.15,4.13,3.63,3.18S119.8,152.73,118.05,151.48Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M119.59,159.8s3.34-8.6-3.2-9.46a15.36,15.36,0,0,0-6.58.84s1.42,4.57,6.58,2.37,1.47-1.94,1.47-1.94S118,157.44,119.59,159.8Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M119.46,151.86s-2.21,1.08-3.6.76-3.14-1.27-2.87-1.77a2,2,0,0,1,1.73-.83A6.87,6.87,0,0,1,119.46,151.86Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M122.31,135.23s-2.67,4.34-6.5,5.17C115.81,140.4,117.14,135.23,122.31,135.23Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.61,116.24a2.43,2.43,0,0,1-.17-.6c0-.06,0-.12,0-.17s0-.08,0-.08h0a0,0,0,0,0,0,0s-.09.13-.11.15a2.22,2.22,0,0,1-.46.51c-.46.38-1,.58-1.23,1a1.09,1.09,0,0,0,0,1,.62.62,0,0,0,.4.33.65.65,0,0,0,.59-.19,1,1,0,0,0,.23-.31.76.76,0,0,0,.5.82.61.61,0,0,0,.5-.11,1.1,1.1,0,0,0,.44-.87A4.56,4.56,0,0,0,64.61,116.24Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.86,119.4a2.38,2.38,0,0,1-.16-.61.88.88,0,0,1,0-.17c0-.05,0-.07,0-.07h0s-.1.13-.11.16a2.23,2.23,0,0,1-.47.5c-.46.39-1,.59-1.23,1a1.09,1.09,0,0,0,0,1,.58.58,0,0,0,1,.14A1,1,0,0,0,63,121a.78.78,0,0,0,.5.82.61.61,0,0,0,.5-.11,1.1,1.1,0,0,0,.44-.87C64.48,120.38,64.1,120,63.86,119.4Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.12,122.55A2.21,2.21,0,0,1,63,122s0-.11,0-.17,0-.07,0-.07h0s-.1.13-.11.16a2.44,2.44,0,0,1-.46.5c-.47.38-1,.59-1.23,1a1.07,1.07,0,0,0,0,1,.58.58,0,0,0,.39.33.66.66,0,0,0,.6-.18,1.31,1.31,0,0,0,.23-.32.77.77,0,0,0,.49.83.64.64,0,0,0,.51-.11,1.07,1.07,0,0,0,.43-.88C63.73,123.54,63.35,123.11,63.12,122.55Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.37,125.71a2.21,2.21,0,0,1-.17-.6,1,1,0,0,1,0-.17s0-.07,0-.08h0s-.09.13-.11.15a2.24,2.24,0,0,1-.46.51c-.47.38-1,.59-1.23,1a1.07,1.07,0,0,0,0,1,.6.6,0,0,0,.39.33.65.65,0,0,0,.6-.18,1.09,1.09,0,0,0,.23-.32.78.78,0,0,0,.5.83.62.62,0,0,0,.5-.12,1.08,1.08,0,0,0,.44-.87C63,126.69,62.6,126.27,62.37,125.71Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.62,128.87a2.21,2.21,0,0,1-.17-.6c0-.06,0-.12,0-.17s0-.07,0-.08h0s-.09.13-.11.15a2.22,2.22,0,0,1-.46.51c-.46.38-1,.58-1.23,1a1.12,1.12,0,0,0,0,1,.62.62,0,0,0,.4.33.64.64,0,0,0,.59-.19,1,1,0,0,0,.23-.31.76.76,0,0,0,.5.82.57.57,0,0,0,.5-.11,1.1,1.1,0,0,0,.44-.87A4.56,4.56,0,0,0,61.62,128.87Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.88,132a2,2,0,0,1-.17-.61.88.88,0,0,1,0-.17s0-.07,0-.07h0s-.1.13-.11.15a2.44,2.44,0,0,1-.46.5c-.47.39-1,.59-1.24,1a1.09,1.09,0,0,0,0,1,.61.61,0,0,0,.39.33.64.64,0,0,0,.59-.19.9.9,0,0,0,.23-.31.78.78,0,0,0,.5.82.61.61,0,0,0,.5-.11,1.07,1.07,0,0,0,.44-.87C61.49,133,61.11,132.58,60.88,132Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.79,135.16a2.1,2.1,0,0,1,0-.62l0-.17c0-.05,0-.07,0-.08h0s-.12.11-.14.13a2.5,2.5,0,0,1-.57.39c-.54.26-1.1.34-1.43.72a1.1,1.1,0,0,0-.24.95.59.59,0,0,0,.93.36,1,1,0,0,0,.3-.26.78.78,0,0,0,.3.92.6.6,0,0,0,.51,0,1.09,1.09,0,0,0,.62-.76A4.57,4.57,0,0,0,59.79,135.16Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.35,138.07a2.19,2.19,0,0,1,0-.63c0-.05,0-.11,0-.16s0-.08,0-.08h0s-.12.11-.14.13a2.18,2.18,0,0,1-.57.38c-.54.27-1.1.35-1.43.72a1.1,1.1,0,0,0-.24,1,.62.62,0,0,0,.31.41.65.65,0,0,0,.62,0,1,1,0,0,0,.3-.26.78.78,0,0,0,.29.92.63.63,0,0,0,.52,0,1,1,0,0,0,.62-.75A4.53,4.53,0,0,0,58.35,138.07Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.9,141a2.63,2.63,0,0,1,0-.63,1.11,1.11,0,0,1,0-.17s0-.07,0-.07h0s-.12.1-.14.12a2.17,2.17,0,0,1-.56.39c-.54.27-1.1.35-1.43.72a1.1,1.1,0,0,0-.24.95.62.62,0,0,0,.31.41.65.65,0,0,0,.62,0,1,1,0,0,0,.29-.26.78.78,0,0,0,.3.92.63.63,0,0,0,.52,0,1.09,1.09,0,0,0,.62-.75A4.3,4.3,0,0,0,56.9,141Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.46,143.88a2.11,2.11,0,0,1,0-.62,1,1,0,0,1,0-.17c0-.05,0-.07,0-.08h0s-.12.11-.14.13a2.68,2.68,0,0,1-.56.39c-.54.27-1.11.34-1.43.72a1.07,1.07,0,0,0-.24.95.62.62,0,0,0,.31.41.66.66,0,0,0,.62,0,1,1,0,0,0,.29-.25.77.77,0,0,0,.3.91.63.63,0,0,0,.52,0,1.14,1.14,0,0,0,.62-.75A4.61,4.61,0,0,0,55.46,143.88Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54,146.79a2.59,2.59,0,0,1,0-.63l0-.16c0-.05,0-.07,0-.08h0s-.12.11-.14.13a2.31,2.31,0,0,1-.56.38c-.54.27-1.11.35-1.44.73a1.11,1.11,0,0,0-.24.94.64.64,0,0,0,.32.41.66.66,0,0,0,.62,0,1.16,1.16,0,0,0,.29-.26.78.78,0,0,0,.3.92.61.61,0,0,0,.51,0,1.12,1.12,0,0,0,.63-.76A4.6,4.6,0,0,0,54,146.79Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.31,149.6a2.2,2.2,0,0,1,0-.62,1,1,0,0,1,0-.17c0-.05,0-.07,0-.08h0s-.13.08-.15.1a2.37,2.37,0,0,1-.61.32,4.53,4.53,0,0,0-1.51.54,1.12,1.12,0,0,0-.35.91.63.63,0,0,0,.26.45.65.65,0,0,0,.62,0,1,1,0,0,0,.33-.22.78.78,0,0,0,.18.95.64.64,0,0,0,.51.06,1.08,1.08,0,0,0,.71-.67A4.42,4.42,0,0,0,52.31,149.6Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.53,152.31a2.62,2.62,0,0,1,0-.62l0-.17a.32.32,0,0,0,0-.07h0s-.13.09-.15.11a2.34,2.34,0,0,1-.61.31,4.53,4.53,0,0,0-1.51.54,1.14,1.14,0,0,0-.35.92.63.63,0,0,0,.26.44.65.65,0,0,0,.62,0,1,1,0,0,0,.33-.22.77.77,0,0,0,.18,1,.61.61,0,0,0,.51.07,1.09,1.09,0,0,0,.71-.68A4.44,4.44,0,0,0,50.53,152.31Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.41,152.4s-1.18-15-22.55-17.28l.41-.75s22.71,1.25,23,18Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M73.21,116.14A4.52,4.52,0,0,1,72.9,115c0-.11,0-.22,0-.33s0-.14,0-.15h0a0,0,0,0,0,0,0c-.06,0-.19.25-.22.3a4.36,4.36,0,0,1-.9,1c-.9.73-1.93,1.11-2.39,2a2.15,2.15,0,0,0-.07,1.9,1.18,1.18,0,0,0,.74.66,1.2,1.2,0,0,0,1.14-.34,1.82,1.82,0,0,0,.45-.6,1.53,1.53,0,0,0,.93,1.63,1.17,1.17,0,0,0,1-.2,2.14,2.14,0,0,0,.87-1.69C74.34,118.08,73.63,117.23,73.21,116.14Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M71.66,122.28a4.52,4.52,0,0,1-.3-1.19c0-.11,0-.22,0-.33a.36.36,0,0,0,0-.15s0,0,0,0,0,0,0,0-.18.25-.21.3a4.61,4.61,0,0,1-.9,1c-.91.73-1.94,1.11-2.4,2a2.19,2.19,0,0,0-.07,1.9,1.21,1.21,0,0,0,.75.67,1.26,1.26,0,0,0,1.14-.34,2.2,2.2,0,0,0,.45-.61,1.51,1.51,0,0,0,.92,1.63,1.15,1.15,0,0,0,1-.2,2.13,2.13,0,0,0,.86-1.69C72.8,124.22,72.09,123.37,71.66,122.28Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M69.85,128.47a4.13,4.13,0,0,1-.1-1.23,2,2,0,0,1,0-.33c0-.09,0-.13,0-.14h0s0,0,0,0-.22.22-.26.26a4.56,4.56,0,0,1-1,.8c-1,.56-2.08.75-2.68,1.51a2.17,2.17,0,0,0-.39,1.87A1.24,1.24,0,0,0,66,132a1.21,1.21,0,0,0,1.18-.14,1.77,1.77,0,0,0,.54-.52,1.54,1.54,0,0,0,.64,1.77,1.18,1.18,0,0,0,1,0,2.12,2.12,0,0,0,1.13-1.52C70.64,130.58,70.09,129.62,69.85,128.47Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M67.3,134.25a4.39,4.39,0,0,1-.09-1.22,1.84,1.84,0,0,1,0-.33c0-.09,0-.14,0-.15h0s0,0,0,0-.22.21-.26.25a4.06,4.06,0,0,1-1,.8c-1,.57-2.09.76-2.68,1.52a2.16,2.16,0,0,0-.39,1.87,1.14,1.14,0,0,0,1.81.64,2,2,0,0,0,.54-.52,1.53,1.53,0,0,0,.64,1.76,1.15,1.15,0,0,0,1,0,2.11,2.11,0,0,0,1.13-1.52C68.11,136.36,67.55,135.41,67.3,134.25Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M64.69,140.08a4.17,4.17,0,0,1,0-1.22l.06-.33c0-.09,0-.14,0-.15h0v0c-.06,0-.24.2-.28.23a4.38,4.38,0,0,1-1.12.7c-1.06.47-2.14.56-2.81,1.27a2.16,2.16,0,0,0-.55,1.82,1.13,1.13,0,0,0,1.74.8,1.72,1.72,0,0,0,.59-.46,1.53,1.53,0,0,0,.48,1.81,1.14,1.14,0,0,0,1,.07A2.12,2.12,0,0,0,65,143.19C65.3,142.26,64.83,141.25,64.69,140.08Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M61.64,145.61a5.08,5.08,0,0,1,0-1.23c0-.1,0-.21.07-.32s0-.14,0-.15h0s0,0,0,0-.24.19-.28.23a4.43,4.43,0,0,1-1.11.7c-1.06.47-2.15.56-2.81,1.26a2.15,2.15,0,0,0-.55,1.82,1.13,1.13,0,0,0,1.74.81,2.14,2.14,0,0,0,.59-.47,1.52,1.52,0,0,0,.48,1.82,1.19,1.19,0,0,0,1,.07A2.16,2.16,0,0,0,62,148.72C62.25,147.78,61.78,146.78,61.64,145.61Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M58.46,151.1a4.64,4.64,0,0,1,.08-1.22,1.67,1.67,0,0,1,.08-.32c0-.09,0-.14,0-.15h0s0,0,0,0-.25.18-.3.21a4.13,4.13,0,0,1-1.14.64c-1.09.41-2.18.45-2.87,1.11a2.11,2.11,0,0,0-.64,1.79,1.17,1.17,0,0,0,.5.86,1.2,1.2,0,0,0,1.19,0,2,2,0,0,0,.62-.44,1.53,1.53,0,0,0,.38,1.85,1.19,1.19,0,0,0,1,.11,2.07,2.07,0,0,0,1.33-1.33C59,153.3,58.54,152.28,58.46,151.1Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.73,130s-9.75-3.25-14.5-19.25H97s1.25,14.62,14.88,20.37Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.86,133.34s-11.3-3.69-16.81-21.84H91.61s1.44,16.59,17.23,23.12Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M34.23,151.12S45,136,41.73,117.5l1.38-.13s3,20.53-8.13,33.83l-.27.26"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12H);
export default __webpack_public_path__ + "static/media/12_h.8beabfe5b7ddbf88a1537f37d2ebf655.svg";
export { ForwardRef as ReactComponent };